// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AuthorizationV1AuthorizeApiToken2Data, AuthorizationV1AuthorizeApiToken2Responses, AuthorizationV1AuthorizeApiTokenData, AuthorizationV1AuthorizeApiTokenResponses, AuthorizationV1HeartbeatData, AuthorizationV1HeartbeatResponses, AuthorizationV1TestStateMismatchData, AuthorizationV1TestStateMismatchResponses, DbAdminLegacyDbDiagram2Data, DbAdminLegacyDbDiagram2Responses, DbAdminLegacyDbDiagramData, DbAdminLegacyDbDiagramPost2Data, DbAdminLegacyDbDiagramPost2Responses, DbAdminLegacyDbDiagramPostData, DbAdminLegacyDbDiagramPostResponses, DbAdminLegacyDbDiagramResponses, DbAdminLegacyFulfillments2Data, DbAdminLegacyFulfillments2Responses, DbAdminLegacyFulfillments3Data, DbAdminLegacyFulfillments3Responses, DbAdminLegacyFulfillmentsData, DbAdminLegacyFulfillmentsResponses, DbAdminLegacyTokenValidationData, DbAdminLegacyTokenValidationResponses, DbAdminV1DbDiagram2Data, DbAdminV1DbDiagram2Responses, DbAdminV1DbDiagramData, DbAdminV1DbDiagramPost2Data, DbAdminV1DbDiagramPost2Responses, DbAdminV1DbDiagramPostData, DbAdminV1DbDiagramPostResponses, DbAdminV1DbDiagramResponses, DbAdminV1Fulfillments2Data, DbAdminV1Fulfillments2Responses, DbAdminV1Fulfillments3Data, DbAdminV1Fulfillments3Responses, DbAdminV1FulfillmentsData, DbAdminV1FulfillmentsResponses, DbAdminV1TokenValidationData, DbAdminV1TokenValidationResponses, EsignatureV1EventCallbackData, EsignatureV1EventCallbackResponses, EsignatureV1OnScreenSignData, EsignatureV1OnScreenSignResponses, EsignatureV1RefreshOrderEsignatureData, EsignatureV1RefreshOrderEsignatureResponses, EsignatureV1RequestOrderEsignatureData, EsignatureV1RequestOrderEsignatureResponses, GetServicesV1FrontrunnerV1MongoDiscoveryEventData, GetServicesV1FrontrunnerV1MongoDiscoveryEventResponses, InsuranceV1CategoriesV1DetailsData, InsuranceV1CategoriesV1DetailsResponses, InsuranceV1CategoriesV1HeartbeatData, InsuranceV1CategoriesV1HeartbeatResponses, InsuranceV1CategoriesV1Search2Data, InsuranceV1CategoriesV1Search2Responses, InsuranceV1CategoriesV1SearchData, InsuranceV1CategoriesV1SearchResponses, InsuranceV1DetailsData, InsuranceV1DetailsResponses, InsuranceV1HeartbeatData, InsuranceV1HeartbeatResponses, InsuranceV1Search2Data, InsuranceV1Search2Responses, InsuranceV1SearchData, InsuranceV1SearchResponses, InsuranceV2GetCarrierProductData, InsuranceV2GetCarrierProductLegacyData, InsuranceV2GetCarrierProductLegacyResponses, InsuranceV2GetCarrierProductResponses, InsuranceV2GetCarrierProductsData, InsuranceV2GetCarrierProductsResponses, InsuranceV2GetCarriersByStateData, InsuranceV2GetCarriersByStateResponses, InsuranceV2GetCoverageZonesData, InsuranceV2GetCoverageZonesResponses, InsuranceV2GetPrimaryIcdsData, InsuranceV2GetPrimaryIcdsResponses, InsuranceV2HeartbeatData, InsuranceV2HeartbeatResponses, InsuranceV2RefillsData, InsuranceV2RefillsResponses, InsuranceV2SearchIcdsData, InsuranceV2SearchIcdsResponses, InsuranceV3CardUploadUrlData, InsuranceV3CardUploadUrlErrors, InsuranceV3CardUploadUrlResponses, InsuranceV3CarrierStatusesV3ListCarrierStatusesData, InsuranceV3CarrierStatusesV3ListCarrierStatusesResponses, InsuranceV3CarriersV3CreateCarrierData, InsuranceV3CarriersV3CreateCarrierResponses, InsuranceV3CarriersV3SearchCarriersData, InsuranceV3CarriersV3SearchCarriersResponses, InsuranceV3CarriersV3UpdateCarrierData, InsuranceV3CarriersV3UpdateCarrierResponses, InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideData, InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideErrors, InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideData, InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideErrors, InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesData, InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponses, InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideData, InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideErrors, InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideResponses, InsuranceV3CoverageZonesV3ListCoverageZonesData, InsuranceV3CoverageZonesV3ListCoverageZonesResponses, InsuranceV3DiscoveryData, InsuranceV3DiscoveryResponses, InsuranceV3GetCarriersByStateData, InsuranceV3GetCarriersByStateResponses, InsuranceV3HeartbeatData, InsuranceV3HeartbeatResponses, InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationData, InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationErrors, InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationData, InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationErrors, InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsData, InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponses, InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationData, InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationErrors, InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationResponses, InsuranceV3OrderDiscoveryData, InsuranceV3OrderDiscoveryResponses, InsuranceV3OrderEligibilityData, InsuranceV3OrderEligibilityResponses, InsuranceV3PlanCodesV3CreatePlanCodeData, InsuranceV3PlanCodesV3CreatePlanCodeResponses, InsuranceV3PlanCodesV3GetPlanCodeData, InsuranceV3PlanCodesV3GetPlanCodeResponses, InsuranceV3PlanCodesV3SearchPlanCodesData, InsuranceV3PlanCodesV3SearchPlanCodesResponses, InsuranceV3PlanCodesV3UpdatePlanCodeData, InsuranceV3PlanCodesV3UpdatePlanCodeResponses, InsuranceV3PlansV3CreatePlanData, InsuranceV3PlansV3CreatePlanResponses, InsuranceV3PlansV3GetPlanData, InsuranceV3PlansV3GetPlanResponses, InsuranceV3PlansV3SearchPlansData, InsuranceV3PlansV3SearchPlansResponses, InsuranceV3PlansV3UpdatePlanData, InsuranceV3PlansV3UpdatePlanResponses, InsuranceV3PutCardsData, InsuranceV3PutCardsErrors, InsuranceV3PutCardsResponses, InsuranceV3TestVerificationKeyData, InsuranceV3TestVerificationKeyResponses, InsuranceV3VerificationData, InsuranceV3VerificationResponses, ManagementV1FeeScheduleV1UpdateFeeScheduleData, ManagementV1FeeScheduleV1UpdateFeeScheduleResponses, NpiV1GetProviderData, NpiV1GetProviderResponses, NpiV1SearchProvidersData, NpiV1SearchProvidersResponses, NpiV2AddProviderAddressData, NpiV2AddProviderAddressResponses, NpiV2GetProviderData, NpiV2GetProviderResponses, NpiV2SearchProvidersData, NpiV2SearchProvidersResponses, NpiV2ToggleProviderAddressData, NpiV2ToggleProviderAddressResponses, NpiV2UpdateProviderAddressData, NpiV2UpdateProviderAddressResponses, NpiV2UpdateProviderData, NpiV2UpdateProviderResponses, OrdersV1AcceptOrderData, OrdersV1AcceptOrderResponses, OrdersV1AssignOrderInsurancesData, OrdersV1AssignOrderInsurancesResponses, OrdersV1AuthorizeData, OrdersV1AuthorizeResponses, OrdersV1AuthRecoveryData, OrdersV1AuthRecoveryResponses, OrdersV1BackfillRxDateData, OrdersV1BackfillRxDateResponses, OrdersV1BillingData, OrdersV1BillingResponses, OrdersV1CreateOrderEndpointData, OrdersV1CreateOrderEndpointResponses, OrdersV1DeleteOrderFileData, OrdersV1DeleteOrderFileResponses, OrdersV1DeleteOrderProductsData, OrdersV1DeleteOrderProductsResponses, OrdersV1DuplicateOrderEndpointData, OrdersV1DuplicateOrderEndpointResponses, OrdersV1GetCarrierCoverageZoneProductsData, OrdersV1GetCarrierCoverageZoneProductsResponses, OrdersV1GetChangeReasonsData, OrdersV1GetChangeReasonsResponses, OrdersV1GetFulfillmentsData, OrdersV1GetFulfillmentsResponses, OrdersV1GetIneligibilityReasonsData, OrdersV1GetIneligibilityReasonsResponses, OrdersV1GetInsuranceCardDownloadUrlData, OrdersV1GetInsuranceCardDownloadUrlResponses, OrdersV1GetOnHoldReasonsData, OrdersV1GetOnHoldReasonsResponses, OrdersV1GetOrderFileData, OrdersV1GetOrderFileResponses, OrdersV1GetOrderFilesData, OrdersV1GetOrderFilesResponses, OrdersV1GetRejectionReasonsData, OrdersV1GetRejectionReasonsResponses, OrdersV1GetTelehealthErrorReasonsData, OrdersV1GetTelehealthErrorReasonsResponses, OrdersV1MoveTempFilesToOrderData, OrdersV1MoveTempFilesToOrderResponses, OrdersV1OrderDetailsData, OrdersV1OrderDetailsResponses, OrdersV1OrderListData, OrdersV1OrderListResponses, OrdersV1OrderScheduleResupplyData, OrdersV1OrderScheduleResupplyResponses, OrdersV1RejectOrderData, OrdersV1RejectOrderResponses, OrdersV1RequestOrderChangesData, OrdersV1RequestOrderChangesResponses, OrdersV1ReviewAuthSubmissionData, OrdersV1ReviewAuthSubmissionResponses, OrdersV1SearchPatientsWithOrdersData, OrdersV1SearchPatientsWithOrdersResponses, OrdersV1SkipOrder2Data, OrdersV1SkipOrder2Responses, OrdersV1SkipOrderData, OrdersV1SkipOrderResponses, OrdersV1ToggleFulfillmentActiveData, OrdersV1ToggleFulfillmentActiveResponses, OrdersV1ToggleFulfillmentInactiveData, OrdersV1ToggleFulfillmentInactiveResponses, OrdersV1UpdateFulfillmentData, OrdersV1UpdateFulfillmentErrors, OrdersV1UpdateFulfillmentResponses, OrdersV1UpdateOrderAssigneeData, OrdersV1UpdateOrderAssigneeResponses, OrdersV1UpdateOrderClinicalDocsData, OrdersV1UpdateOrderClinicalDocsResponses, OrdersV1UpdateOrderContactData, OrdersV1UpdateOrderContactResponses, OrdersV1UpdateOrderInsuranceData, OrdersV1UpdateOrderInsuranceResponses, OrdersV1UpdateOrderPatientData, OrdersV1UpdateOrderPatientResponses, OrdersV1UpdateOrderPhysicianData, OrdersV1UpdateOrderPhysicianResponses, OrdersV1UpdateOrderProductsData, OrdersV1UpdateOrderProductsResponses, OrdersV1UpdateOrderReferralData, OrdersV1UpdateOrderReferralResponses, OrdersV1UpdateOrderShippingAddressData, OrdersV1UpdateOrderShippingAddressResponses, OrdersV1UpdateOrderSupplierData, OrdersV1UpdateOrderSupplierResponses, OrdersV1UpdateRxDateData, OrdersV1UpdateRxDateResponses, OrdersV1UploadOrderFileData, OrdersV1UploadOrderFileResponses, OrdersV1UploadOrderTmpFileData, OrdersV1UploadOrderTmpFileResponses, OrdersV2DuplicateOrderV2Data, OrdersV2DuplicateOrderV2Responses, OrdersV2GetOrderStatusesV2Data, OrdersV2GetOrderStatusesV2Responses, OrdersV2MoveOrderToBillingData, OrdersV2MoveOrderToBillingResponses, OrdersV2MoveOrderToCantReachPatientData, OrdersV2MoveOrderToCantReachPatientResponses, OrdersV2MoveOrderToDoneData, OrdersV2MoveOrderToDoneResponses, OrdersV2MoveOrderToInProgressWithSupplierData, OrdersV2MoveOrderToInProgressWithSupplierResponses, OrdersV2MoveOrderToOnHoldWithSupplierData, OrdersV2MoveOrderToOnHoldWithSupplierResponses, OrdersV2MoveOrderToPendingAuthorizationData, OrdersV2MoveOrderToPendingAuthorizationResponses, OrdersV2MoveOrderToPendingRerouteData, OrdersV2MoveOrderToPendingRerouteResponses, OrdersV2MoveOrderToPendingSupplierAcceptanceData, OrdersV2MoveOrderToPendingSupplierAcceptanceResponses, OrdersV2MoveOrderToPreparingShipmentData, OrdersV2MoveOrderToPreparingShipmentResponses, OrdersV2MoveOrderToSupplierCompletedData, OrdersV2MoveOrderToSupplierCompletedResponses, OrdersV2MoveOrderToSupplierShippedData, OrdersV2MoveOrderToSupplierShippedResponses, OrdersV2MoveOrderToTelehealthChasingClinicalsData, OrdersV2MoveOrderToTelehealthChasingClinicalsResponses, OrdersV2MoveOrderToTelehealthCompletedData, OrdersV2MoveOrderToTelehealthCompletedResponses, OrdersV2MoveOrderToTelehealthContactingPatientData, OrdersV2MoveOrderToTelehealthContactingPatientResponses, OrdersV2MoveOrderToTelehealthNeedsReschedulingData, OrdersV2MoveOrderToTelehealthNeedsReschedulingResponses, OrdersV2MoveOrderToTelehealthOnHoldData, OrdersV2MoveOrderToTelehealthOnHoldResponses, OrdersV2MoveOrderToTelehealthPostVisitCompletedData, OrdersV2MoveOrderToTelehealthPostVisitCompletedResponses, OrdersV2MoveOrderToTelehealthUpcomingData, OrdersV2MoveOrderToTelehealthUpcomingResponses, OrdersV2RefreshEsignatureData, OrdersV2RefreshEsignatureResponses, OrdersV2RequestEsignatureData, OrdersV2RequestEsignatureResponses, OrdersV4CreateOrderDtcEndpointData, OrdersV4CreateOrderDtcEndpointResponses, OrdersV4CreateOrderMcpEndpointData, OrdersV4CreateOrderMcpEndpointResponses, OrdersV4EscalateMcpOrderData, OrdersV4EscalateMcpOrderResponses, OrdersV4PatchManualVerificationData, OrdersV4PatchManualVerificationErrors, OrdersV4PatchManualVerificationResponses, OrdersV5OrderDetailsData, OrdersV5OrderDetailsResponses, OrganizationsV1CreateOrganizationData, OrganizationsV1CreateOrganizationResponses, OrganizationsV1GetOrganizationData, OrganizationsV1GetOrganizationResponses, OrganizationsV1SearchOrganizationsData, OrganizationsV1SearchOrganizationsResponses, OrganizationsV1UpdateOrganizationData, OrganizationsV1UpdateOrganizationResponses, PatientsV2HeartbeatData, PatientsV2HeartbeatResponses, PatientsV2PatientAddressesData, PatientsV2PatientAddressesResponses, PatientsV2PatientContactsData, PatientsV2PatientContactsResponses, PatientsV2PatientDetailsData, PatientsV2PatientDetailsResponses, PatientsV2PatientInsurancesData, PatientsV2PatientInsurancesResponses, PatientsV2PatientOrdersData, PatientsV2PatientOrdersResponses, PatientsV2ReassignPatientData, PatientsV2ReassignPatientResponses, PatientsV2SearchPatientsData, PatientsV2SearchPatientsResponses, PostProductsV2CartV2CreateUpdateCartData, PostProductsV2CartV2CreateUpdateCartResponses, PostServicesV1FrontrunnerV1MongoDiscoveryEventData, PostServicesV1FrontrunnerV1MongoDiscoveryEventResponses, ProductsV1CategoriesV1HeartbeatData, ProductsV1CategoriesV1HeartbeatResponses, ProductsV1CategoriesV1SearchData, ProductsV1CategoriesV1SearchResponses, ProductsV1HeartbeatData, ProductsV1HeartbeatResponses, ProductsV1ProductDetailsData, ProductsV1ProductDetailsResponses, ProductsV1SearchProductsData, ProductsV1SearchProductsResponses, ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductData, ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductResponses, ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductData, ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductResponses, ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductData, ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductResponses, ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsData, ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsResponses, ProductsV2CarrierCoverageZoneProductsV2HeartbeatData, ProductsV2CarrierCoverageZoneProductsV2HeartbeatResponses, ProductsV2CartV2DeleteCartData, ProductsV2CartV2DeleteCartResponses, ProductsV2CartV2GetCartData, ProductsV2CartV2GetCartResponses, ProductsV2CategoriesV2GetAllCategoriesData, ProductsV2CategoriesV2GetAllCategoriesResponses, ProductsV2CategoriesV2HeartbeatData, ProductsV2CategoriesV2HeartbeatResponses, ProductsV2CategoriesV2SearchCategoriesData, ProductsV2CategoriesV2SearchCategoriesResponses, ProductsV2EditProductData, ProductsV2EditProductResponses, ProductsV2FoldProducts2Data, ProductsV2FoldProducts2Responses, ProductsV2FoldProducts3Data, ProductsV2FoldProducts3Responses, ProductsV2FoldProducts4Data, ProductsV2FoldProducts4Responses, ProductsV2FoldProductsData, ProductsV2FoldProductsResponses, ProductsV2GetProductDetailsData, ProductsV2GetProductDetailsResponses, ProductsV2HeartbeatData, ProductsV2HeartbeatResponses, ProductsV2SearchProductsData, ProductsV2SearchProductsResponses, ProductsV3ExportCatalog2Data, ProductsV3ExportCatalog2Responses, ProductsV3ExportCatalogData, ProductsV3ExportCatalogResponses, ProductsV3GetCategoriesData, ProductsV3GetCategoriesResponses, ProductsV3GetCoverageZonesData, ProductsV3GetCoverageZonesResponses, ProductsV3GetProductsData, ProductsV3GetProductsResponses, ProductsV3HeartbeatData, ProductsV3HeartbeatResponses, ProductsV4GetAllCategoriesData, ProductsV4GetAllCategoriesResponses, ProductsV4GetCarriersData, ProductsV4GetCarriersResponses, ProductsV4GetCatalogProductData, ProductsV4GetCatalogProductResponses, ProductsV4GetCatalogProductsData, ProductsV4GetCatalogProductsResponses, ProductsV4GetCoverageZonesData, ProductsV4GetCoverageZonesResponses, ProductsV4GetFeeScheduleData, ProductsV4GetFeeScheduleResponses, ProductsV4GetProductAuditData, ProductsV4GetProductAuditResponses, ProductsV4GetProductDetailData, ProductsV4GetProductDetailResponses, ProductsV4SearchCategoriesData, ProductsV4SearchCategoriesResponses, ProductsV4SearchProductsData, ProductsV4SearchProductsResponses, PutProductsV2CartV2CreateUpdateCartData, PutProductsV2CartV2CreateUpdateCartResponses, SchedulingV3CalcomWebhookData, SchedulingV3CalcomWebhookErrors, SchedulingV3CalcomWebhookResponses, SchedulingV3GetSlotsData, SchedulingV3GetSlotsErrors, SchedulingV3GetSlotsResponses, SchedulingV3ReserveSlotData, SchedulingV3ReserveSlotErrors, SchedulingV3ReserveSlotResponses, SchedulingV4BookSelfScheduledAppointmentData, SchedulingV4BookSelfScheduledAppointmentErrors, SchedulingV4BookSelfScheduledAppointmentResponses, SchedulingV4CancelAppointmentData, SchedulingV4CancelAppointmentErrors, SchedulingV4CancelAppointmentResponses, SchedulingV4GetAppointmentData, SchedulingV4GetAppointmentErrors, SchedulingV4GetAppointmentResponses, SchedulingV4GetDaysData, SchedulingV4GetDaysErrors, SchedulingV4GetDaysResponses, SchedulingV4GetSlotsData, SchedulingV4GetSlotsErrors, SchedulingV4GetSlotsResponses, SchedulingV4RescheduleAppointmentData, SchedulingV4RescheduleAppointmentErrors, SchedulingV4RescheduleAppointmentResponses, SchedulingV4VerifyPatientBookingData, SchedulingV4VerifyPatientBookingErrors, SchedulingV4VerifyPatientBookingResponses, ServicesV1Auth0V1DuplicateAuth0UsersData, ServicesV1Auth0V1DuplicateAuth0UsersResponses, ServicesV1Auth0V1ExportAuth0UsersData, ServicesV1Auth0V1ExportAuth0UsersResponses, ServicesV1Auth0V1GetAuth0UserData, ServicesV1Auth0V1GetAuth0UserResponses, ServicesV1Auth0V1HeartbeatData, ServicesV1Auth0V1HeartbeatResponses, ServicesV1Auth0V1ListAuth0Users2Data, ServicesV1Auth0V1ListAuth0Users2Responses, ServicesV1Auth0V1ListAuth0UsersData, ServicesV1Auth0V1ListAuth0UsersResponses, ServicesV1CandidV1GenerateEncounterPayloadData, ServicesV1CandidV1GenerateEncounterPayloadErrors, ServicesV1CandidV1GenerateEncounterPayloadResponses, ServicesV1CandidV1HeartbeatData, ServicesV1CandidV1HeartbeatResponses, ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Data, ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Responses, ServicesV1EpacesV1CancelPriorAuthorizationsForOrderData, ServicesV1EpacesV1CancelPriorAuthorizationsForOrderResponses, ServicesV1EpacesV1GetEligibilityResponsesData, ServicesV1EpacesV1GetEligibilityResponsesResponses, ServicesV1EpacesV1GetPriorAuthorizationResponsesData, ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderData, ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderResponses, ServicesV1EpacesV1GetPriorAuthorizationResponsesResponses, ServicesV1EpacesV1HeartbeatData, ServicesV1EpacesV1HeartbeatResponses, ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Data, ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Responses, ServicesV1EpacesV1SubmitPriorAuthorizationForOrderData, ServicesV1EpacesV1SubmitPriorAuthorizationForOrderResponses, ServicesV1FrontrunnerV1DiscoveryByOrderEndpointData, ServicesV1FrontrunnerV1DiscoveryByOrderEndpointResponses, ServicesV1FrontrunnerV1DiscoveryByPatientEndpointData, ServicesV1FrontrunnerV1DiscoveryByPatientEndpointResponses, ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Data, ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Responses, ServicesV1FrontrunnerV1EligibilityByOrderEndpointData, ServicesV1FrontrunnerV1EligibilityByOrderEndpointResponses, ServicesV1FrontrunnerV1EligibilityByPatientEndpointData, ServicesV1FrontrunnerV1EligibilityByPatientEndpointResponses, ServicesV1FrontrunnerV1HeartbeatData, ServicesV1FrontrunnerV1HeartbeatResponses, ServicesV1FrontrunnerV1MockDiscoveryData, ServicesV1FrontrunnerV1MockDiscoveryResponses, ServicesV1FrontrunnerV1MongoDiscoverySourceData, ServicesV1FrontrunnerV1MongoDiscoverySourceResponses, ServicesV1FrontrunnerV1MongoEligibilityEvent2Data, ServicesV1FrontrunnerV1MongoEligibilityEvent2Responses, ServicesV1FrontrunnerV1MongoEligibilityEventData, ServicesV1FrontrunnerV1MongoEligibilityEventResponses, ServicesV1FrontrunnerV1MongoEligibilitySource2Data, ServicesV1FrontrunnerV1MongoEligibilitySource2Responses, ServicesV1FrontrunnerV1MongoEligibilitySourceData, ServicesV1FrontrunnerV1MongoEligibilitySourceResponses, ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointData, ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointResponses, ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointData, ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointResponses, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Data, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Responses, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointData, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointResponses, ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointData, ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointResponses, ServicesV1HeartbeatData, ServicesV1HeartbeatResponses, ServicesV1HubspotV1ContactsData, ServicesV1HubspotV1ContactsResponses, ServicesV1HubspotV1HeartbeatData, ServicesV1HubspotV1HeartbeatResponses, ServicesV1HubspotV1IngestContactsData, ServicesV1HubspotV1IngestContactsResponses, ServicesV1HubspotV1IngestOrdersData, ServicesV1HubspotV1IngestOrdersResponses, ServicesV1HubspotV1OrdersData, ServicesV1HubspotV1OrdersResponses, ServicesV1HubspotV1ProductsData, ServicesV1HubspotV1ProductsResponses, ServicesV1IntercomV1IntercomSendReplyData, ServicesV1IntercomV1IntercomSendReplyResponses, ServicesV1LuminaV1HeartbeatData, ServicesV1LuminaV1HeartbeatResponses, ServicesV1LuminaV1SubmitOrderData, ServicesV1LuminaV1SubmitOrderResponses, ServicesV1SlackV1SlackPostData, ServicesV1SlackV1SlackPostResponses, ServicesV2FrontrunnerV2HeartbeatData, ServicesV2FrontrunnerV2HeartbeatResponses, ServicesV2FrontrunnerV2PipelineReplayData, ServicesV2FrontrunnerV2PipelineReplayResponses, ServicesV2HeartbeatData, ServicesV2HeartbeatResponses, SessionsV3PreviewSessionData, SessionsV3PreviewSessionErrors, SessionsV3PreviewSessionResponses, SessionsV3SaveSessionData, SessionsV3SaveSessionErrors, SessionsV3SaveSessionResponses, SessionsV3VerifySessionData, SessionsV3VerifySessionErrors, SessionsV3VerifySessionResponses, SuppliersV1DetailsData, SuppliersV1DetailsResponses, SuppliersV1GetAllSuppliersData, SuppliersV1GetAllSuppliersResponses, SuppliersV1HeartbeatData, SuppliersV1HeartbeatResponses, SuppliersV1Search2Data, SuppliersV1Search2Responses, SuppliersV1SearchData, SuppliersV1SearchResponses, SuppliersV2DetailsData, SuppliersV2DetailsResponses, SuppliersV2GetAllSuppliersData, SuppliersV2GetAllSuppliersResponses, SuppliersV2HeartbeatData, SuppliersV2HeartbeatResponses, SuppliersV2Search2Data, SuppliersV2Search2Responses, SuppliersV2SearchData, SuppliersV2SearchResponses, SystemV1AggregateLegacyContactsData, SystemV1AggregateLegacyContactsResponses, SystemV1AnalyzeProgressNoteRouteData, SystemV1AnalyzeProgressNoteRouteResponses, SystemV1AxiomStatusData, SystemV1AxiomStatusResponses, SystemV1ClearAxiomData, SystemV1ClearAxiomResponses, SystemV1CurrentAxiomData, SystemV1CurrentAxiomResponses, SystemV1DisableCurrentAxiomOrderData, SystemV1DisableCurrentAxiomOrderResponses, SystemV1EpacesData, SystemV1EpacesResponses, SystemV1GenerateLomnRouteData, SystemV1GenerateLomnRouteResponses, SystemV1HeartbeatData, SystemV1HeartbeatResponses, SystemV1ListOrderedTables2Data, SystemV1ListOrderedTables2Responses, SystemV1ListOrderedTablesData, SystemV1ListOrderedTablesResponses, SystemV1LomnHistoryData, SystemV1LomnHistoryResponses, SystemV1LomnPdfData, SystemV1LomnPdfResponses, SystemV1LomnRequirementsData, SystemV1LomnRequirementsResponses, SystemV1MessageConversionEventsData, SystemV1MessageConversionEventsResponses, SystemV1MigrateLegacyPatientsRouteData, SystemV1MigrateLegacyPatientsRouteResponses, SystemV1MigrateMongoOrdersRouteData, SystemV1MigrateMongoOrdersRouteResponses, SystemV1MongoHealthData, SystemV1MongoHealthResponses, SystemV1PdfReaderData, SystemV1PdfReaderResponses, SystemV1ProduceMessageData, SystemV1ProduceMessageResponses, SystemV1SyncMongoOrdersByIdData, SystemV1SyncMongoOrdersByIdResponses, SystemV1TriggerResupplyReportData, SystemV1TriggerResupplyReportResponses, TrackingV4VerifyAndGetTrackingData, TrackingV4VerifyAndGetTrackingResponses, UsersV1ActivateUserData, UsersV1ActivateUserResponses, UsersV1CreateUserData, UsersV1CreateUserResponses, UsersV1DeleteUserData, UsersV1DeleteUserResponses, UsersV1GetUserData, UsersV1GetUserResponses, UsersV1SearchUsersData, UsersV1SearchUsersResponses, UsersV1UpdateUserData, UsersV1UpdateUserResponses, VerifyV3CheckData, VerifyV3CheckErrors, VerifyV3CheckResponses, VerifyV3StartData, VerifyV3StartErrors, VerifyV3StartResponses } from './types.gen';
import { zAuthorizationV1AuthorizeApiToken2Response, zAuthorizationV1AuthorizeApiTokenResponse, zAuthorizationV1HeartbeatResponse, zAuthorizationV1TestStateMismatchResponse, zDbAdminLegacyDbDiagram2Response, zDbAdminLegacyDbDiagramPost2Response, zDbAdminLegacyDbDiagramPostResponse, zDbAdminLegacyDbDiagramResponse, zDbAdminLegacyFulfillments2Response, zDbAdminLegacyFulfillments3Response, zDbAdminLegacyFulfillmentsResponse, zDbAdminLegacyTokenValidationResponse, zDbAdminV1DbDiagram2Response, zDbAdminV1DbDiagramPost2Response, zDbAdminV1DbDiagramPostResponse, zDbAdminV1DbDiagramResponse, zDbAdminV1Fulfillments2Response, zDbAdminV1Fulfillments3Response, zDbAdminV1FulfillmentsResponse, zDbAdminV1TokenValidationResponse, zEsignatureV1EventCallbackResponse, zEsignatureV1OnScreenSignResponse, zEsignatureV1RefreshOrderEsignatureResponse, zEsignatureV1RequestOrderEsignatureResponse, zGetServicesV1FrontrunnerV1MongoDiscoveryEventResponse, zInsuranceV1CategoriesV1DetailsResponse, zInsuranceV1CategoriesV1HeartbeatResponse, zInsuranceV1CategoriesV1Search2Response, zInsuranceV1CategoriesV1SearchResponse, zInsuranceV1DetailsResponse, zInsuranceV1HeartbeatResponse, zInsuranceV1Search2Response, zInsuranceV1SearchResponse, zInsuranceV2GetCarrierProductLegacyResponse, zInsuranceV2GetCarrierProductResponse, zInsuranceV2GetCarrierProductsResponse, zInsuranceV2GetCarriersByStateResponse, zInsuranceV2GetCoverageZonesResponse, zInsuranceV2GetPrimaryIcdsResponse, zInsuranceV2HeartbeatResponse, zInsuranceV2RefillsResponse, zInsuranceV2SearchIcdsResponse, zInsuranceV3CardUploadUrlResponse, zInsuranceV3CarrierStatusesV3ListCarrierStatusesResponse, zInsuranceV3CarriersV3CreateCarrierResponse, zInsuranceV3CarriersV3SearchCarriersResponse, zInsuranceV3CarriersV3UpdateCarrierResponse, zInsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideResponse, zInsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideResponse, zInsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponse, zInsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideResponse, zInsuranceV3CoverageZonesV3ListCoverageZonesResponse, zInsuranceV3DiscoveryResponse, zInsuranceV3GetCarriersByStateResponse, zInsuranceV3HeartbeatResponse, zInsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationResponse, zInsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationResponse, zInsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponse, zInsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationResponse, zInsuranceV3PlanCodesV3CreatePlanCodeResponse, zInsuranceV3PlanCodesV3GetPlanCodeResponse, zInsuranceV3PlanCodesV3SearchPlanCodesResponse, zInsuranceV3PlanCodesV3UpdatePlanCodeResponse, zInsuranceV3PlansV3CreatePlanResponse, zInsuranceV3PlansV3GetPlanResponse, zInsuranceV3PlansV3SearchPlansResponse, zInsuranceV3PlansV3UpdatePlanResponse, zInsuranceV3PutCardsResponse, zInsuranceV3TestVerificationKeyResponse, zInsuranceV3VerificationResponse, zManagementV1FeeScheduleV1UpdateFeeScheduleResponse, zNpiV1GetProviderResponse, zNpiV1SearchProvidersResponse, zNpiV2AddProviderAddressResponse, zNpiV2GetProviderResponse, zNpiV2SearchProvidersResponse, zNpiV2ToggleProviderAddressResponse, zNpiV2UpdateProviderAddressResponse, zNpiV2UpdateProviderResponse, zOrdersV1AcceptOrderResponse, zOrdersV1AssignOrderInsurancesResponse, zOrdersV1AuthorizeResponse, zOrdersV1AuthRecoveryResponse, zOrdersV1BackfillRxDateResponse, zOrdersV1BillingResponse, zOrdersV1CreateOrderEndpointResponse, zOrdersV1DeleteOrderFileResponse, zOrdersV1DeleteOrderProductsResponse, zOrdersV1DuplicateOrderEndpointResponse, zOrdersV1GetCarrierCoverageZoneProductsResponse, zOrdersV1GetChangeReasonsResponse, zOrdersV1GetFulfillmentsResponse, zOrdersV1GetIneligibilityReasonsResponse, zOrdersV1GetInsuranceCardDownloadUrlResponse, zOrdersV1GetOnHoldReasonsResponse, zOrdersV1GetOrderFileResponse, zOrdersV1GetOrderFilesResponse, zOrdersV1GetRejectionReasonsResponse, zOrdersV1GetTelehealthErrorReasonsResponse, zOrdersV1MoveTempFilesToOrderResponse, zOrdersV1OrderDetailsResponse, zOrdersV1OrderListResponse, zOrdersV1OrderScheduleResupplyResponse, zOrdersV1RejectOrderResponse, zOrdersV1RequestOrderChangesResponse, zOrdersV1ReviewAuthSubmissionResponse, zOrdersV1SearchPatientsWithOrdersResponse, zOrdersV1SkipOrder2Response, zOrdersV1SkipOrderResponse, zOrdersV1ToggleFulfillmentActiveResponse, zOrdersV1ToggleFulfillmentInactiveResponse, zOrdersV1UpdateFulfillmentResponse, zOrdersV1UpdateOrderAssigneeResponse, zOrdersV1UpdateOrderClinicalDocsResponse, zOrdersV1UpdateOrderContactResponse, zOrdersV1UpdateOrderInsuranceResponse, zOrdersV1UpdateOrderPatientResponse, zOrdersV1UpdateOrderPhysicianResponse, zOrdersV1UpdateOrderProductsResponse, zOrdersV1UpdateOrderReferralResponse, zOrdersV1UpdateOrderShippingAddressResponse, zOrdersV1UpdateOrderSupplierResponse, zOrdersV1UpdateRxDateResponse, zOrdersV1UploadOrderFileResponse, zOrdersV1UploadOrderTmpFileResponse, zOrdersV2DuplicateOrderV2Response, zOrdersV2GetOrderStatusesV2Response, zOrdersV2MoveOrderToBillingResponse, zOrdersV2MoveOrderToCantReachPatientResponse, zOrdersV2MoveOrderToDoneResponse, zOrdersV2MoveOrderToInProgressWithSupplierResponse, zOrdersV2MoveOrderToOnHoldWithSupplierResponse, zOrdersV2MoveOrderToPendingAuthorizationResponse, zOrdersV2MoveOrderToPendingRerouteResponse, zOrdersV2MoveOrderToPendingSupplierAcceptanceResponse, zOrdersV2MoveOrderToPreparingShipmentResponse, zOrdersV2MoveOrderToSupplierCompletedResponse, zOrdersV2MoveOrderToSupplierShippedResponse, zOrdersV2MoveOrderToTelehealthChasingClinicalsResponse, zOrdersV2MoveOrderToTelehealthCompletedResponse, zOrdersV2MoveOrderToTelehealthContactingPatientResponse, zOrdersV2MoveOrderToTelehealthNeedsReschedulingResponse, zOrdersV2MoveOrderToTelehealthOnHoldResponse, zOrdersV2MoveOrderToTelehealthPostVisitCompletedResponse, zOrdersV2MoveOrderToTelehealthUpcomingResponse, zOrdersV2RefreshEsignatureResponse, zOrdersV2RequestEsignatureResponse, zOrdersV4CreateOrderDtcEndpointResponse, zOrdersV4CreateOrderMcpEndpointResponse, zOrdersV4EscalateMcpOrderResponse, zOrdersV4PatchManualVerificationResponse, zOrdersV5OrderDetailsResponse, zOrganizationsV1CreateOrganizationResponse, zOrganizationsV1GetOrganizationResponse, zOrganizationsV1SearchOrganizationsResponse, zOrganizationsV1UpdateOrganizationResponse, zPatientsV2HeartbeatResponse, zPatientsV2PatientAddressesResponse, zPatientsV2PatientContactsResponse, zPatientsV2PatientDetailsResponse, zPatientsV2PatientInsurancesResponse, zPatientsV2PatientOrdersResponse, zPatientsV2ReassignPatientResponse, zPatientsV2SearchPatientsResponse, zPostProductsV2CartV2CreateUpdateCartResponse, zPostServicesV1FrontrunnerV1MongoDiscoveryEventResponse, zProductsV1CategoriesV1HeartbeatResponse, zProductsV1CategoriesV1SearchResponse, zProductsV1HeartbeatResponse, zProductsV1ProductDetailsResponse, zProductsV1SearchProductsResponse, zProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductResponse, zProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductResponse, zProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductResponse, zProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsResponse, zProductsV2CarrierCoverageZoneProductsV2HeartbeatResponse, zProductsV2CartV2DeleteCartResponse, zProductsV2CartV2GetCartResponse, zProductsV2CategoriesV2GetAllCategoriesResponse, zProductsV2CategoriesV2HeartbeatResponse, zProductsV2CategoriesV2SearchCategoriesResponse, zProductsV2EditProductResponse, zProductsV2FoldProducts2Response, zProductsV2FoldProducts3Response, zProductsV2FoldProducts4Response, zProductsV2FoldProductsResponse, zProductsV2GetProductDetailsResponse, zProductsV2HeartbeatResponse, zProductsV2SearchProductsResponse, zProductsV3ExportCatalog2Response, zProductsV3ExportCatalogResponse, zProductsV3GetCategoriesResponse, zProductsV3GetCoverageZonesResponse, zProductsV3GetProductsResponse, zProductsV3HeartbeatResponse, zProductsV4GetAllCategoriesResponse, zProductsV4GetCarriersResponse, zProductsV4GetCatalogProductResponse, zProductsV4GetCatalogProductsResponse, zProductsV4GetCoverageZonesResponse, zProductsV4GetFeeScheduleResponse, zProductsV4GetProductAuditResponse, zProductsV4GetProductDetailResponse, zProductsV4SearchCategoriesResponse, zProductsV4SearchProductsResponse, zPutProductsV2CartV2CreateUpdateCartResponse, zSchedulingV3CalcomWebhookResponse, zSchedulingV3GetSlotsResponse, zSchedulingV3ReserveSlotResponse, zSchedulingV4BookSelfScheduledAppointmentResponse, zSchedulingV4CancelAppointmentResponse, zSchedulingV4GetAppointmentResponse, zSchedulingV4GetDaysResponse, zSchedulingV4GetSlotsResponse, zSchedulingV4RescheduleAppointmentResponse, zSchedulingV4VerifyPatientBookingResponse, zServicesV1Auth0V1DuplicateAuth0UsersResponse, zServicesV1Auth0V1ExportAuth0UsersResponse, zServicesV1Auth0V1GetAuth0UserResponse, zServicesV1Auth0V1HeartbeatResponse, zServicesV1Auth0V1ListAuth0Users2Response, zServicesV1Auth0V1ListAuth0UsersResponse, zServicesV1CandidV1GenerateEncounterPayloadResponse, zServicesV1CandidV1HeartbeatResponse, zServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Response, zServicesV1EpacesV1CancelPriorAuthorizationsForOrderResponse, zServicesV1EpacesV1GetEligibilityResponsesResponse, zServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderResponse, zServicesV1EpacesV1GetPriorAuthorizationResponsesResponse, zServicesV1EpacesV1HeartbeatResponse, zServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Response, zServicesV1EpacesV1SubmitPriorAuthorizationForOrderResponse, zServicesV1FrontrunnerV1DiscoveryByOrderEndpointResponse, zServicesV1FrontrunnerV1DiscoveryByPatientEndpointResponse, zServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Response, zServicesV1FrontrunnerV1EligibilityByOrderEndpointResponse, zServicesV1FrontrunnerV1EligibilityByPatientEndpointResponse, zServicesV1FrontrunnerV1HeartbeatResponse, zServicesV1FrontrunnerV1MockDiscoveryResponse, zServicesV1FrontrunnerV1MongoDiscoverySourceResponse, zServicesV1FrontrunnerV1MongoEligibilityEvent2Response, zServicesV1FrontrunnerV1MongoEligibilityEventResponse, zServicesV1FrontrunnerV1MongoEligibilitySource2Response, zServicesV1FrontrunnerV1MongoEligibilitySourceResponse, zServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointResponse, zServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointResponse, zServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Response, zServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointResponse, zServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointResponse, zServicesV1HeartbeatResponse, zServicesV1HubspotV1ContactsResponse, zServicesV1HubspotV1HeartbeatResponse, zServicesV1HubspotV1IngestContactsResponse, zServicesV1HubspotV1IngestOrdersResponse, zServicesV1HubspotV1OrdersResponse, zServicesV1HubspotV1ProductsResponse, zServicesV1IntercomV1IntercomSendReplyResponse, zServicesV1LuminaV1HeartbeatResponse, zServicesV1LuminaV1SubmitOrderResponse, zServicesV1SlackV1SlackPostResponse, zServicesV2FrontrunnerV2HeartbeatResponse, zServicesV2FrontrunnerV2PipelineReplayResponse, zServicesV2HeartbeatResponse, zSessionsV3PreviewSessionResponse, zSessionsV3SaveSessionResponse, zSessionsV3VerifySessionResponse, zSuppliersV1DetailsResponse, zSuppliersV1GetAllSuppliersResponse, zSuppliersV1HeartbeatResponse, zSuppliersV1Search2Response, zSuppliersV1SearchResponse, zSuppliersV2DetailsResponse, zSuppliersV2GetAllSuppliersResponse, zSuppliersV2HeartbeatResponse, zSuppliersV2Search2Response, zSuppliersV2SearchResponse, zSystemV1AggregateLegacyContactsResponse, zSystemV1AnalyzeProgressNoteRouteResponse, zSystemV1AxiomStatusResponse, zSystemV1ClearAxiomResponse, zSystemV1CurrentAxiomResponse, zSystemV1DisableCurrentAxiomOrderResponse, zSystemV1EpacesResponse, zSystemV1GenerateLomnRouteResponse, zSystemV1HeartbeatResponse, zSystemV1ListOrderedTables2Response, zSystemV1ListOrderedTablesResponse, zSystemV1LomnHistoryResponse, zSystemV1LomnPdfResponse, zSystemV1LomnRequirementsResponse, zSystemV1MessageConversionEventsResponse, zSystemV1MigrateLegacyPatientsRouteResponse, zSystemV1MigrateMongoOrdersRouteResponse, zSystemV1MongoHealthResponse, zSystemV1PdfReaderResponse, zSystemV1ProduceMessageResponse, zSystemV1SyncMongoOrdersByIdResponse, zSystemV1TriggerResupplyReportResponse, zTrackingV4VerifyAndGetTrackingResponse, zUsersV1ActivateUserResponse, zUsersV1CreateUserResponse, zUsersV1DeleteUserResponse, zUsersV1GetUserResponse, zUsersV1SearchUsersResponse, zUsersV1UpdateUserResponse, zVerifyV3CheckResponse, zVerifyV3StartResponse } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminLegacyDbDiagram = <ThrowOnError extends boolean = true>(options?: Options<DbAdminLegacyDbDiagramData, ThrowOnError>): RequestResult<DbAdminLegacyDbDiagramResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DbAdminLegacyDbDiagramResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminLegacyDbDiagramResponse.parseAsync(data),
    url: '/api/legacy/db/admin/db-diagram',
    ...options
});

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminLegacyDbDiagramPost = <ThrowOnError extends boolean = true>(options?: Options<DbAdminLegacyDbDiagramPostData, ThrowOnError>): RequestResult<DbAdminLegacyDbDiagramPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<DbAdminLegacyDbDiagramPostResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminLegacyDbDiagramPostResponse.parseAsync(data),
    url: '/api/legacy/db/admin/db-diagram',
    ...options
});

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminLegacyDbDiagram2 = <ThrowOnError extends boolean = true>(options: Options<DbAdminLegacyDbDiagram2Data, ThrowOnError>): RequestResult<DbAdminLegacyDbDiagram2Responses, unknown, ThrowOnError> => (options.client ?? client).get<DbAdminLegacyDbDiagram2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminLegacyDbDiagram2Response.parseAsync(data),
    url: '/api/legacy/db/admin/db-diagram/{bind_key}',
    ...options
});

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminLegacyDbDiagramPost2 = <ThrowOnError extends boolean = true>(options: Options<DbAdminLegacyDbDiagramPost2Data, ThrowOnError>): RequestResult<DbAdminLegacyDbDiagramPost2Responses, unknown, ThrowOnError> => (options.client ?? client).post<DbAdminLegacyDbDiagramPost2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminLegacyDbDiagramPost2Response.parseAsync(data),
    url: '/api/legacy/db/admin/db-diagram/{bind_key}',
    ...options
});

export const dbAdminLegacyFulfillments = <ThrowOnError extends boolean = true>(options?: Options<DbAdminLegacyFulfillmentsData, ThrowOnError>): RequestResult<DbAdminLegacyFulfillmentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DbAdminLegacyFulfillmentsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminLegacyFulfillmentsResponse.parseAsync(data),
    url: '/api/legacy/db/admin/orders/fulfillments',
    ...options
});

export const dbAdminLegacyFulfillments2 = <ThrowOnError extends boolean = true>(options: Options<DbAdminLegacyFulfillments2Data, ThrowOnError>): RequestResult<DbAdminLegacyFulfillments2Responses, unknown, ThrowOnError> => (options.client ?? client).get<DbAdminLegacyFulfillments2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminLegacyFulfillments2Response.parseAsync(data),
    url: '/api/legacy/db/admin/orders/fulfillments/{upper_bound}',
    ...options
});

export const dbAdminLegacyFulfillments3 = <ThrowOnError extends boolean = true>(options: Options<DbAdminLegacyFulfillments3Data, ThrowOnError>): RequestResult<DbAdminLegacyFulfillments3Responses, unknown, ThrowOnError> => (options.client ?? client).get<DbAdminLegacyFulfillments3Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminLegacyFulfillments3Response.parseAsync(data),
    url: '/api/legacy/db/admin/orders/fulfillments/{upper_bound}/{lower_bound}',
    ...options
});

/**
 * Validate Token
 *
 * Token testing
 */
export const dbAdminLegacyTokenValidation = <ThrowOnError extends boolean = true>(options: Options<DbAdminLegacyTokenValidationData, ThrowOnError>): RequestResult<DbAdminLegacyTokenValidationResponses, unknown, ThrowOnError> => (options.client ?? client).post<DbAdminLegacyTokenValidationResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminLegacyTokenValidationResponse.parseAsync(data),
    url: '/api/legacy/db/admin/validate-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authorizationV1AuthorizeApiToken = <ThrowOnError extends boolean = true>(options?: Options<AuthorizationV1AuthorizeApiTokenData, ThrowOnError>): RequestResult<AuthorizationV1AuthorizeApiTokenResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuthorizationV1AuthorizeApiTokenResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zAuthorizationV1AuthorizeApiTokenResponse.parseAsync(data),
    url: '/api/v1/authorization/authorize_api_token',
    ...options
});

export const authorizationV1AuthorizeApiToken2 = <ThrowOnError extends boolean = true>(options: Options<AuthorizationV1AuthorizeApiToken2Data, ThrowOnError>): RequestResult<AuthorizationV1AuthorizeApiToken2Responses, unknown, ThrowOnError> => (options.client ?? client).get<AuthorizationV1AuthorizeApiToken2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zAuthorizationV1AuthorizeApiToken2Response.parseAsync(data),
    url: '/api/v1/authorization/authorize_api_token/{token}',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const authorizationV1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<AuthorizationV1HeartbeatData, ThrowOnError>): RequestResult<AuthorizationV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuthorizationV1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zAuthorizationV1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/authorization/heartbeat',
    ...options
});

/**
 * Test endpoint to simulate mismatching_state error.
 *
 * This endpoint clears the session and then redirects to the callback
 * with fake OAuth parameters, triggering a state mismatch.
 */
export const authorizationV1TestStateMismatch = <ThrowOnError extends boolean = true>(options?: Options<AuthorizationV1TestStateMismatchData, ThrowOnError>): RequestResult<AuthorizationV1TestStateMismatchResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuthorizationV1TestStateMismatchResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zAuthorizationV1TestStateMismatchResponse.parseAsync(data),
    url: '/api/v1/authorization/test_state_mismatch',
    ...options
});

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminV1DbDiagram = <ThrowOnError extends boolean = true>(options?: Options<DbAdminV1DbDiagramData, ThrowOnError>): RequestResult<DbAdminV1DbDiagramResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DbAdminV1DbDiagramResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminV1DbDiagramResponse.parseAsync(data),
    url: '/api/v1/db/admin/db-diagram',
    ...options
});

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminV1DbDiagramPost = <ThrowOnError extends boolean = true>(options?: Options<DbAdminV1DbDiagramPostData, ThrowOnError>): RequestResult<DbAdminV1DbDiagramPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<DbAdminV1DbDiagramPostResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminV1DbDiagramPostResponse.parseAsync(data),
    url: '/api/v1/db/admin/db-diagram',
    ...options
});

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminV1DbDiagram2 = <ThrowOnError extends boolean = true>(options: Options<DbAdminV1DbDiagram2Data, ThrowOnError>): RequestResult<DbAdminV1DbDiagram2Responses, unknown, ThrowOnError> => (options.client ?? client).get<DbAdminV1DbDiagram2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminV1DbDiagram2Response.parseAsync(data),
    url: '/api/v1/db/admin/db-diagram/{bind_key}',
    ...options
});

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminV1DbDiagramPost2 = <ThrowOnError extends boolean = true>(options: Options<DbAdminV1DbDiagramPost2Data, ThrowOnError>): RequestResult<DbAdminV1DbDiagramPost2Responses, unknown, ThrowOnError> => (options.client ?? client).post<DbAdminV1DbDiagramPost2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminV1DbDiagramPost2Response.parseAsync(data),
    url: '/api/v1/db/admin/db-diagram/{bind_key}',
    ...options
});

export const dbAdminV1Fulfillments = <ThrowOnError extends boolean = true>(options?: Options<DbAdminV1FulfillmentsData, ThrowOnError>): RequestResult<DbAdminV1FulfillmentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DbAdminV1FulfillmentsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminV1FulfillmentsResponse.parseAsync(data),
    url: '/api/v1/db/admin/orders/fulfillments',
    ...options
});

export const dbAdminV1Fulfillments2 = <ThrowOnError extends boolean = true>(options: Options<DbAdminV1Fulfillments2Data, ThrowOnError>): RequestResult<DbAdminV1Fulfillments2Responses, unknown, ThrowOnError> => (options.client ?? client).get<DbAdminV1Fulfillments2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminV1Fulfillments2Response.parseAsync(data),
    url: '/api/v1/db/admin/orders/fulfillments/{upper_bound}',
    ...options
});

export const dbAdminV1Fulfillments3 = <ThrowOnError extends boolean = true>(options: Options<DbAdminV1Fulfillments3Data, ThrowOnError>): RequestResult<DbAdminV1Fulfillments3Responses, unknown, ThrowOnError> => (options.client ?? client).get<DbAdminV1Fulfillments3Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminV1Fulfillments3Response.parseAsync(data),
    url: '/api/v1/db/admin/orders/fulfillments/{upper_bound}/{lower_bound}',
    ...options
});

/**
 * Validate Token
 *
 * Token testing
 */
export const dbAdminV1TokenValidation = <ThrowOnError extends boolean = true>(options: Options<DbAdminV1TokenValidationData, ThrowOnError>): RequestResult<DbAdminV1TokenValidationResponses, unknown, ThrowOnError> => (options.client ?? client).post<DbAdminV1TokenValidationResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDbAdminV1TokenValidationResponse.parseAsync(data),
    url: '/api/v1/db/admin/validate-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const esignatureV1EventCallback = <ThrowOnError extends boolean = true>(options: Options<EsignatureV1EventCallbackData, ThrowOnError>): RequestResult<EsignatureV1EventCallbackResponses, unknown, ThrowOnError> => (options.client ?? client).post<EsignatureV1EventCallbackResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zEsignatureV1EventCallbackResponse.parseAsync(data),
    url: '/api/v1/esignature/callback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const esignatureV1OnScreenSign = <ThrowOnError extends boolean = true>(options: Options<EsignatureV1OnScreenSignData, ThrowOnError>): RequestResult<EsignatureV1OnScreenSignResponses, unknown, ThrowOnError> => (options.client ?? client).get<EsignatureV1OnScreenSignResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zEsignatureV1OnScreenSignResponse.parseAsync(data),
    url: '/api/v1/esignature/sign/on-screen/{envelope_id}',
    ...options
});

export const esignatureV1RequestOrderEsignature = <ThrowOnError extends boolean = true>(options: Options<EsignatureV1RequestOrderEsignatureData, ThrowOnError>): RequestResult<EsignatureV1RequestOrderEsignatureResponses, unknown, ThrowOnError> => (options.client ?? client).post<EsignatureV1RequestOrderEsignatureResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zEsignatureV1RequestOrderEsignatureResponse.parseAsync(data),
    url: '/api/v1/esignature/{order_id}/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const esignatureV1RefreshOrderEsignature = <ThrowOnError extends boolean = true>(options: Options<EsignatureV1RefreshOrderEsignatureData, ThrowOnError>): RequestResult<EsignatureV1RefreshOrderEsignatureResponses, unknown, ThrowOnError> => (options.client ?? client).post<EsignatureV1RefreshOrderEsignatureResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zEsignatureV1RefreshOrderEsignatureResponse.parseAsync(data),
    url: '/api/v1/esignature/{order_id}/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Details
 *
 * Retrieve the extended Code Category record by uuid
 */
export const insuranceV1CategoriesV1Details = <ThrowOnError extends boolean = true>(options: Options<InsuranceV1CategoriesV1DetailsData, ThrowOnError>): RequestResult<InsuranceV1CategoriesV1DetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV1CategoriesV1DetailsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV1CategoriesV1DetailsResponse.parseAsync(data),
    url: '/api/v1/insurance/categories/details/{code_category_id}',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const insuranceV1CategoriesV1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV1CategoriesV1HeartbeatData, ThrowOnError>): RequestResult<InsuranceV1CategoriesV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV1CategoriesV1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV1CategoriesV1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/insurance/categories/heartbeat',
    ...options
});

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1CategoriesV1Search = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV1CategoriesV1SearchData, ThrowOnError>): RequestResult<InsuranceV1CategoriesV1SearchResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV1CategoriesV1SearchResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV1CategoriesV1SearchResponse.parseAsync(data),
    url: '/api/v1/insurance/categories/search',
    ...options
});

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1CategoriesV1Search2 = <ThrowOnError extends boolean = true>(options: Options<InsuranceV1CategoriesV1Search2Data, ThrowOnError>): RequestResult<InsuranceV1CategoriesV1Search2Responses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV1CategoriesV1Search2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV1CategoriesV1Search2Response.parseAsync(data),
    url: '/api/v1/insurance/categories/search/{category}',
    ...options
});

/**
 * Details
 *
 * Retrieve the extended Insurance record by uuid
 */
export const insuranceV1Details = <ThrowOnError extends boolean = true>(options: Options<InsuranceV1DetailsData, ThrowOnError>): RequestResult<InsuranceV1DetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV1DetailsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV1DetailsResponse.parseAsync(data),
    url: '/api/v1/insurance/details/{insurance_id}',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const insuranceV1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV1HeartbeatData, ThrowOnError>): RequestResult<InsuranceV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/insurance/heartbeat',
    ...options
});

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1Search = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV1SearchData, ThrowOnError>): RequestResult<InsuranceV1SearchResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV1SearchResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV1SearchResponse.parseAsync(data),
    url: '/api/v1/insurance/search',
    ...options
});

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1Search2 = <ThrowOnError extends boolean = true>(options: Options<InsuranceV1Search2Data, ThrowOnError>): RequestResult<InsuranceV1Search2Responses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV1Search2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV1Search2Response.parseAsync(data),
    url: '/api/v1/insurance/search/{category}',
    ...options
});

export const managementV1FeeScheduleV1UpdateFeeSchedule = <ThrowOnError extends boolean = true>(options: Options<ManagementV1FeeScheduleV1UpdateFeeScheduleData, ThrowOnError>): RequestResult<ManagementV1FeeScheduleV1UpdateFeeScheduleResponses, unknown, ThrowOnError> => (options.client ?? client).put<ManagementV1FeeScheduleV1UpdateFeeScheduleResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zManagementV1FeeScheduleV1UpdateFeeScheduleResponse.parseAsync(data),
    url: '/api/v1/management/fee_schedule/{fee_schedule_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const npiV1SearchProviders = <ThrowOnError extends boolean = true>(options: Options<NpiV1SearchProvidersData, ThrowOnError>): RequestResult<NpiV1SearchProvidersResponses, unknown, ThrowOnError> => (options.client ?? client).get<NpiV1SearchProvidersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zNpiV1SearchProvidersResponse.parseAsync(data),
    url: '/api/v1/npi/search',
    ...options
});

export const npiV1GetProvider = <ThrowOnError extends boolean = true>(options: Options<NpiV1GetProviderData, ThrowOnError>): RequestResult<NpiV1GetProviderResponses, unknown, ThrowOnError> => (options.client ?? client).get<NpiV1GetProviderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zNpiV1GetProviderResponse.parseAsync(data),
    url: '/api/v1/npi/{npi}',
    ...options
});

/**
 * Authorize order endpoint
 *
 * Flags orders as ready for authorization.
 * N.B. Provided fulfillment ids should be associated with its order id
 * or that auth request will specifically fail
 */
export const ordersV1Authorize = <ThrowOnError extends boolean = true>(options: Options<OrdersV1AuthorizeData, ThrowOnError>): RequestResult<OrdersV1AuthorizeResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1AuthorizeResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1AuthorizeResponse.parseAsync(data),
    url: '/api/v1/orders/authorize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Billing order endpoint
 *
 * Send billing information to Candid Health.
 */
export const ordersV1Billing = <ThrowOnError extends boolean = true>(options: Options<OrdersV1BillingData, ThrowOnError>): RequestResult<OrdersV1BillingResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1BillingResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1BillingResponse.parseAsync(data),
    url: '/api/v1/orders/billing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Return the list of valid order change request reasons.
 *
 * Migrated from orders GraphQL query: getChangeReasons
 */
export const ordersV1GetChangeReasons = <ThrowOnError extends boolean = true>(options?: Options<OrdersV1GetChangeReasonsData, ThrowOnError>): RequestResult<OrdersV1GetChangeReasonsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1GetChangeReasonsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1GetChangeReasonsResponse.parseAsync(data),
    url: '/api/v1/orders/change-reasons',
    ...options
});

export const ordersV1CreateOrderEndpoint = <ThrowOnError extends boolean = true>(options: Options<OrdersV1CreateOrderEndpointData, ThrowOnError>): RequestResult<OrdersV1CreateOrderEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1CreateOrderEndpointResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1CreateOrderEndpointResponse.parseAsync(data),
    url: '/api/v1/orders/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV1MoveTempFilesToOrder = <ThrowOnError extends boolean = true>(options: Options<OrdersV1MoveTempFilesToOrderData, ThrowOnError>): RequestResult<OrdersV1MoveTempFilesToOrderResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1MoveTempFilesToOrderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1MoveTempFilesToOrderResponse.parseAsync(data),
    url: '/api/v1/orders/documents/move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV1UploadOrderTmpFile = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UploadOrderTmpFileData, ThrowOnError>): RequestResult<OrdersV1UploadOrderTmpFileResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1UploadOrderTmpFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zOrdersV1UploadOrderTmpFileResponse.parseAsync(data),
    url: '/api/v1/orders/documents/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Update fulfillment authorization status and related fields.
 */
export const ordersV1UpdateFulfillment = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UpdateFulfillmentData, ThrowOnError>): RequestResult<OrdersV1UpdateFulfillmentResponses, OrdersV1UpdateFulfillmentErrors, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateFulfillmentResponses, OrdersV1UpdateFulfillmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1UpdateFulfillmentResponse.parseAsync(data),
    url: '/api/v1/orders/fulfillments/{fulfillment_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV1GetFulfillments = <ThrowOnError extends boolean = true>(options: Options<OrdersV1GetFulfillmentsData, ThrowOnError>): RequestResult<OrdersV1GetFulfillmentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1GetFulfillmentsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1GetFulfillmentsResponse.parseAsync(data),
    url: '/api/v1/orders/get_fulfillments',
    ...options
});

/**
 * Return the list of valid insurance ineligibility reasons.
 *
 * Migrated from orders GraphQL query: getIneligibilityReasons
 */
export const ordersV1GetIneligibilityReasons = <ThrowOnError extends boolean = true>(options?: Options<OrdersV1GetIneligibilityReasonsData, ThrowOnError>): RequestResult<OrdersV1GetIneligibilityReasonsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1GetIneligibilityReasonsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1GetIneligibilityReasonsResponse.parseAsync(data),
    url: '/api/v1/orders/ineligibility-reasons',
    ...options
});

/**
 * Return the list of valid on-hold reasons for supplier hold actions.
 *
 * Migrated from orders GraphQL query: getOnHoldReasons
 */
export const ordersV1GetOnHoldReasons = <ThrowOnError extends boolean = true>(options?: Options<OrdersV1GetOnHoldReasonsData, ThrowOnError>): RequestResult<OrdersV1GetOnHoldReasonsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1GetOnHoldReasonsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1GetOnHoldReasonsResponse.parseAsync(data),
    url: '/api/v1/orders/on-hold-reasons',
    ...options
});

/**
 * Return the list of valid order rejection reasons, filtered by caller role.
 *
 * Migrated from orders GraphQL query: getRejectionReasons
 */
export const ordersV1GetRejectionReasons = <ThrowOnError extends boolean = true>(options?: Options<OrdersV1GetRejectionReasonsData, ThrowOnError>): RequestResult<OrdersV1GetRejectionReasonsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1GetRejectionReasonsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1GetRejectionReasonsResponse.parseAsync(data),
    url: '/api/v1/orders/rejection-reasons',
    ...options
});

/**
 * Backfill prescription_metadata from legacy prescription_expiration field.
 *
 * Targets orders where ``prescription_expiration`` is set AND
 * ``prescription_metadata`` is None. Idempotent — skips orders that already
 * have ``prescription_metadata``.
 *
 * Pass ``{"dry_run": true}`` to preview matching order IDs without writing.
 * Otherwise enqueues a Celery task and returns ``{"task_id": "..."}`` with 202.
 */
export const ordersV1BackfillRxDate = <ThrowOnError extends boolean = true>(options: Options<OrdersV1BackfillRxDateData, ThrowOnError>): RequestResult<OrdersV1BackfillRxDateResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1BackfillRxDateResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1BackfillRxDateResponse.parseAsync(data),
    url: '/api/v1/orders/rx-date/backfill',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV1OrderList = <ThrowOnError extends boolean = true>(options?: Options<OrdersV1OrderListData, ThrowOnError>): RequestResult<OrdersV1OrderListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1OrderListResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1OrderListResponse.parseAsync(data),
    url: '/api/v1/orders/search',
    ...options
});

/**
 * Search orders by patient name or order ID, grouped by patient.
 *
 * Query parameter:
 * query (str) — patient first/last name substring, or a numeric order ID.
 *
 * Migrated from orders GraphQL query: searchPatientsWithOrders
 */
export const ordersV1SearchPatientsWithOrders = <ThrowOnError extends boolean = true>(options?: Options<OrdersV1SearchPatientsWithOrdersData, ThrowOnError>): RequestResult<OrdersV1SearchPatientsWithOrdersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1SearchPatientsWithOrdersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1SearchPatientsWithOrdersResponse.parseAsync(data),
    url: '/api/v1/orders/search/patients',
    ...options
});

/**
 * Return the list of valid telehealth error reasons for rescheduling actions.
 *
 * Migrated from orders GraphQL query: getTelehealthErrorReasons
 */
export const ordersV1GetTelehealthErrorReasons = <ThrowOnError extends boolean = true>(options?: Options<OrdersV1GetTelehealthErrorReasonsData, ThrowOnError>): RequestResult<OrdersV1GetTelehealthErrorReasonsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1GetTelehealthErrorReasonsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1GetTelehealthErrorReasonsResponse.parseAsync(data),
    url: '/api/v1/orders/telehealth-error-reasons',
    ...options
});

export const ordersV1OrderDetails = <ThrowOnError extends boolean = true>(options: Options<OrdersV1OrderDetailsData, ThrowOnError>): RequestResult<OrdersV1OrderDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1OrderDetailsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1OrderDetailsResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}',
    ...options
});

/**
 * Accept a pending order.
 *
 * Migrated from orders GraphQL mutation: acceptOrder
 */
export const ordersV1AcceptOrder = <ThrowOnError extends boolean = true>(options: Options<OrdersV1AcceptOrderData, ThrowOnError>): RequestResult<OrdersV1AcceptOrderResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1AcceptOrderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1AcceptOrderResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/accept',
    ...options
});

export const ordersV1UpdateOrderAssignee = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UpdateOrderAssigneeData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderAssigneeResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderAssigneeResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1UpdateOrderAssigneeResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/assignee/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Recover epaces authorization info
 *
 * - This will retireve auth info for a given order targeting a specific date authorization was run
 * - This is meant to be used when auth is run manually after updating the order
 * - NOTE: fulfillment authorization_date_embargo and authorization_date_start must  be set, otherwise no fulfillments will be found
 * - The target date will supercede these values
 */
export const ordersV1AuthRecovery = <ThrowOnError extends boolean = true>(options: Options<OrdersV1AuthRecoveryData, ThrowOnError>): RequestResult<OrdersV1AuthRecoveryResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1AuthRecoveryResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1AuthRecoveryResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/auth/recover/{target_date}',
    ...options
});

export const ordersV1ReviewAuthSubmission = <ThrowOnError extends boolean = true>(options: Options<OrdersV1ReviewAuthSubmissionData, ThrowOnError>): RequestResult<OrdersV1ReviewAuthSubmissionResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1ReviewAuthSubmissionResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1ReviewAuthSubmissionResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/auth/submission',
    ...options
});

/**
 * Get all CarrierCoverageZoneProducts for the order's items
 */
export const ordersV1GetCarrierCoverageZoneProducts = <ThrowOnError extends boolean = true>(options: Options<OrdersV1GetCarrierCoverageZoneProductsData, ThrowOnError>): RequestResult<OrdersV1GetCarrierCoverageZoneProductsResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1GetCarrierCoverageZoneProductsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1GetCarrierCoverageZoneProductsResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/carrier_coverage_zone_products',
    ...options
});

export const ordersV1UpdateOrderClinicalDocs = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UpdateOrderClinicalDocsData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderClinicalDocsResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderClinicalDocsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1UpdateOrderClinicalDocsResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/clinical-docs/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV1UpdateOrderContact = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UpdateOrderContactData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderContactResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderContactResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1UpdateOrderContactResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/contact/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV1GetOrderFiles = <ThrowOnError extends boolean = true>(options: Options<OrdersV1GetOrderFilesData, ThrowOnError>): RequestResult<OrdersV1GetOrderFilesResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1GetOrderFilesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1GetOrderFilesResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/documents',
    ...options
});

export const ordersV1UploadOrderFile = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UploadOrderFileData, ThrowOnError>): RequestResult<OrdersV1UploadOrderFileResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1UploadOrderFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zOrdersV1UploadOrderFileResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/documents/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const ordersV1DeleteOrderFile = <ThrowOnError extends boolean = true>(options: Options<OrdersV1DeleteOrderFileData, ThrowOnError>): RequestResult<OrdersV1DeleteOrderFileResponses, unknown, ThrowOnError> => (options.client ?? client).delete<OrdersV1DeleteOrderFileResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1DeleteOrderFileResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/documents/{key}',
    ...options
});

export const ordersV1GetOrderFile = <ThrowOnError extends boolean = true>(options: Options<OrdersV1GetOrderFileData, ThrowOnError>): RequestResult<OrdersV1GetOrderFileResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1GetOrderFileResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1GetOrderFileResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/documents/{key}',
    ...options
});

export const ordersV1DuplicateOrderEndpoint = <ThrowOnError extends boolean = true>(options: Options<OrdersV1DuplicateOrderEndpointData, ThrowOnError>): RequestResult<OrdersV1DuplicateOrderEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1DuplicateOrderEndpointResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1DuplicateOrderEndpointResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/duplicate',
    ...options
});

export const ordersV1ToggleFulfillmentActive = <ThrowOnError extends boolean = true>(options: Options<OrdersV1ToggleFulfillmentActiveData, ThrowOnError>): RequestResult<OrdersV1ToggleFulfillmentActiveResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1ToggleFulfillmentActiveResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1ToggleFulfillmentActiveResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/fulfillment/activate/{product_id}',
    ...options
});

export const ordersV1ToggleFulfillmentInactive = <ThrowOnError extends boolean = true>(options: Options<OrdersV1ToggleFulfillmentInactiveData, ThrowOnError>): RequestResult<OrdersV1ToggleFulfillmentInactiveResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1ToggleFulfillmentInactiveResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1ToggleFulfillmentInactiveResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/fulfillment/deactivate/{product_id}',
    ...options
});

export const ordersV1GetInsuranceCardDownloadUrl = <ThrowOnError extends boolean = true>(options: Options<OrdersV1GetInsuranceCardDownloadUrlData, ThrowOnError>): RequestResult<OrdersV1GetInsuranceCardDownloadUrlResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1GetInsuranceCardDownloadUrlResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1GetInsuranceCardDownloadUrlResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/insurance-cards',
    ...options
});

/**
 * Update a single insurance (primary or secondary) on an order.
 *
 * Migrated from orders GraphQL mutation: updateOrderInsurance
 */
export const ordersV1UpdateOrderInsurance = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UpdateOrderInsuranceData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderInsuranceResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderInsuranceResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1UpdateOrderInsuranceResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/insurance/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign Order Insurances
 *
 * Assigns a new slate of insurance information to the order.
 * Expects all insurances to be provided in the request.
 * At least one insurance must be marked as primary.
 * No more than one can be secondary.
 * Any insurances not provided will be deleted from the order.
 */
export const ordersV1AssignOrderInsurances = <ThrowOnError extends boolean = true>(options: Options<OrdersV1AssignOrderInsurancesData, ThrowOnError>): RequestResult<OrdersV1AssignOrderInsurancesResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1AssignOrderInsurancesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1AssignOrderInsurancesResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/insurances/assign-all',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV1DeleteOrderProducts = <ThrowOnError extends boolean = true>(options: Options<OrdersV1DeleteOrderProductsData, ThrowOnError>): RequestResult<OrdersV1DeleteOrderProductsResponses, unknown, ThrowOnError> => (options.client ?? client).delete<OrdersV1DeleteOrderProductsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1DeleteOrderProductsResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/items/{product_id}/delete',
    ...options
});

export const ordersV1UpdateOrderProducts = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UpdateOrderProductsData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderProductsResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderProductsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1UpdateOrderProductsResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/items/{product_id}/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV1UpdateOrderPatient = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UpdateOrderPatientData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderPatientResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderPatientResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1UpdateOrderPatientResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/patient/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV1UpdateOrderPhysician = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UpdateOrderPhysicianData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderPhysicianResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderPhysicianResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1UpdateOrderPhysicianResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/physician/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update the referring physician (name, phone, email only) on an order.
 *
 * Migrated from orders GraphQL mutation: updateOrderReferral
 */
export const ordersV1UpdateOrderReferral = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UpdateOrderReferralData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderReferralResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderReferralResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1UpdateOrderReferralResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/referral/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject a pending order.
 *
 * Migrated from orders GraphQL mutation: rejectOrder
 */
export const ordersV1RejectOrder = <ThrowOnError extends boolean = true>(options: Options<OrdersV1RejectOrderData, ThrowOnError>): RequestResult<OrdersV1RejectOrderResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1RejectOrderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1RejectOrderResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request changes on an order.
 *
 * Migrated from orders GraphQL mutation: requestChanges
 */
export const ordersV1RequestOrderChanges = <ThrowOnError extends boolean = true>(options: Options<OrdersV1RequestOrderChangesData, ThrowOnError>): RequestResult<OrdersV1RequestOrderChangesResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1RequestOrderChangesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1RequestOrderChangesResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/request-changes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Manually set the RX expiration date on an order.
 *
 * Sets default source=Manual otherwise leaves as is.
 * ``reference`` is taken from the request body when
 * provided (e.g. "Fax from Dr. Smith office"); falls back to the requesting
 * user's email when omitted. Does not touch ``signing_date`` — that field is
 * set only by the DocuSign callback.
 */
export const ordersV1UpdateRxDate = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UpdateRxDateData, ThrowOnError>): RequestResult<OrdersV1UpdateRxDateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateRxDateResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1UpdateRxDateResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/rx-date/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV1OrderScheduleResupply = <ThrowOnError extends boolean = true>(options: Options<OrdersV1OrderScheduleResupplyData, ThrowOnError>): RequestResult<OrdersV1OrderScheduleResupplyResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1OrderScheduleResupplyResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1OrderScheduleResupplyResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/schedule/resupply',
    ...options
});

export const ordersV1UpdateOrderShippingAddress = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UpdateOrderShippingAddressData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderShippingAddressResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderShippingAddressResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1UpdateOrderShippingAddressResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/shipping-address/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV1SkipOrder = <ThrowOnError extends boolean = true>(options: Options<OrdersV1SkipOrderData, ThrowOnError>): RequestResult<OrdersV1SkipOrderResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1SkipOrderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1SkipOrderResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/skip',
    ...options
});

export const ordersV1SkipOrder2 = <ThrowOnError extends boolean = true>(options: Options<OrdersV1SkipOrder2Data, ThrowOnError>): RequestResult<OrdersV1SkipOrder2Responses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1SkipOrder2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1SkipOrder2Response.parseAsync(data),
    url: '/api/v1/orders/{order_id}/skip/{days}',
    ...options
});

export const ordersV1UpdateOrderSupplier = <ThrowOnError extends boolean = true>(options: Options<OrdersV1UpdateOrderSupplierData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderSupplierResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderSupplierResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV1UpdateOrderSupplierResponse.parseAsync(data),
    url: '/api/v1/orders/{order_id}/supplier/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const organizationsV1CreateOrganization = <ThrowOnError extends boolean = true>(options: Options<OrganizationsV1CreateOrganizationData, ThrowOnError>): RequestResult<OrganizationsV1CreateOrganizationResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrganizationsV1CreateOrganizationResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrganizationsV1CreateOrganizationResponse.parseAsync(data),
    url: '/api/v1/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const organizationsV1SearchOrganizations = <ThrowOnError extends boolean = true>(options?: Options<OrganizationsV1SearchOrganizationsData, ThrowOnError>): RequestResult<OrganizationsV1SearchOrganizationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrganizationsV1SearchOrganizationsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrganizationsV1SearchOrganizationsResponse.parseAsync(data),
    url: '/api/v1/organizations/search',
    ...options
});

export const organizationsV1GetOrganization = <ThrowOnError extends boolean = true>(options: Options<OrganizationsV1GetOrganizationData, ThrowOnError>): RequestResult<OrganizationsV1GetOrganizationResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrganizationsV1GetOrganizationResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrganizationsV1GetOrganizationResponse.parseAsync(data),
    url: '/api/v1/organizations/{organization_id}',
    ...options
});

export const organizationsV1UpdateOrganization = <ThrowOnError extends boolean = true>(options: Options<OrganizationsV1UpdateOrganizationData, ThrowOnError>): RequestResult<OrganizationsV1UpdateOrganizationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrganizationsV1UpdateOrganizationResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrganizationsV1UpdateOrganizationResponse.parseAsync(data),
    url: '/api/v1/organizations/{organization_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV1CategoriesV1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ProductsV1CategoriesV1HeartbeatData, ThrowOnError>): RequestResult<ProductsV1CategoriesV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV1CategoriesV1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV1CategoriesV1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/products/categories/heartbeat',
    ...options
});

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const productsV1CategoriesV1Search = <ThrowOnError extends boolean = true>(options?: Options<ProductsV1CategoriesV1SearchData, ThrowOnError>): RequestResult<ProductsV1CategoriesV1SearchResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV1CategoriesV1SearchResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV1CategoriesV1SearchResponse.parseAsync(data),
    url: '/api/v1/products/categories/search',
    ...options
});

/**
 * Details
 *
 * Retrieve the extended Product record by uuid
 */
export const productsV1ProductDetails = <ThrowOnError extends boolean = true>(options: Options<ProductsV1ProductDetailsData, ThrowOnError>): RequestResult<ProductsV1ProductDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV1ProductDetailsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV1ProductDetailsResponse.parseAsync(data),
    url: '/api/v1/products/details/{product_id}',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ProductsV1HeartbeatData, ThrowOnError>): RequestResult<ProductsV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/products/heartbeat',
    ...options
});

/**
 * Search Products
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const productsV1SearchProducts = <ThrowOnError extends boolean = true>(options?: Options<ProductsV1SearchProductsData, ThrowOnError>): RequestResult<ProductsV1SearchProductsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV1SearchProductsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV1SearchProductsResponse.parseAsync(data),
    url: '/api/v1/products/search',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1Auth0V1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1Auth0V1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1Auth0V1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1Auth0V1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1Auth0V1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/services/auth0/heartbeat',
    ...options
});

/**
 * Auth0 Users
 *
 * Retrieve 1 auth0 registered user based on provided user_id
 */
export const servicesV1Auth0V1GetAuth0User = <ThrowOnError extends boolean = true>(options: Options<ServicesV1Auth0V1GetAuth0UserData, ThrowOnError>): RequestResult<ServicesV1Auth0V1GetAuth0UserResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1Auth0V1GetAuth0UserResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1Auth0V1GetAuth0UserResponse.parseAsync(data),
    url: '/api/v1/services/auth0/user/{user_id}',
    ...options
});

/**
 * Auth0 Users
 *
 * Retrieve list of a max of 1000 auth0 registered users for current tenant
 */
export const servicesV1Auth0V1ListAuth0Users = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1Auth0V1ListAuth0UsersData, ThrowOnError>): RequestResult<ServicesV1Auth0V1ListAuth0UsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1Auth0V1ListAuth0UsersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1Auth0V1ListAuth0UsersResponse.parseAsync(data),
    url: '/api/v1/services/auth0/users',
    ...options
});

/**
 * Auth0 Users
 *
 * Retrieve list of all auth0 registered users for current tenant
 */
export const servicesV1Auth0V1DuplicateAuth0Users = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1Auth0V1DuplicateAuth0UsersData, ThrowOnError>): RequestResult<ServicesV1Auth0V1DuplicateAuth0UsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1Auth0V1DuplicateAuth0UsersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1Auth0V1DuplicateAuth0UsersResponse.parseAsync(data),
    url: '/api/v1/services/auth0/users/duplicates',
    ...options
});

/**
 * Auth0 Users
 *
 * Retrieve list of all auth0 registered users for current tenant
 */
export const servicesV1Auth0V1ExportAuth0Users = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1Auth0V1ExportAuth0UsersData, ThrowOnError>): RequestResult<ServicesV1Auth0V1ExportAuth0UsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1Auth0V1ExportAuth0UsersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1Auth0V1ExportAuth0UsersResponse.parseAsync(data),
    url: '/api/v1/services/auth0/users/export',
    ...options
});

/**
 * Auth0 Users
 *
 * Retrieve list of a max of 1000 auth0 registered users for current tenant
 */
export const servicesV1Auth0V1ListAuth0Users2 = <ThrowOnError extends boolean = true>(options: Options<ServicesV1Auth0V1ListAuth0Users2Data, ThrowOnError>): RequestResult<ServicesV1Auth0V1ListAuth0Users2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1Auth0V1ListAuth0Users2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1Auth0V1ListAuth0Users2Response.parseAsync(data),
    url: '/api/v1/services/auth0/users/{search_term}',
    ...options
});

/**
 * Candid Payload
 *
 * Generate the payload that is sent when order is submitted to candid
 */
export const servicesV1CandidV1GenerateEncounterPayload = <ThrowOnError extends boolean = true>(options: Options<ServicesV1CandidV1GenerateEncounterPayloadData, ThrowOnError>): RequestResult<ServicesV1CandidV1GenerateEncounterPayloadResponses, ServicesV1CandidV1GenerateEncounterPayloadErrors, ThrowOnError> => (options.client ?? client).get<ServicesV1CandidV1GenerateEncounterPayloadResponses, ServicesV1CandidV1GenerateEncounterPayloadErrors, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1CandidV1GenerateEncounterPayloadResponse.parseAsync(data),
    url: '/api/v1/services/candid/encounter/{order_id}',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1CandidV1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1CandidV1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1CandidV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1CandidV1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1CandidV1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/services/candid/heartbeat',
    ...options
});

export const servicesV1EpacesV1GetEligibilityResponses = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1EpacesV1GetEligibilityResponsesData, ThrowOnError>): RequestResult<ServicesV1EpacesV1GetEligibilityResponsesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1EpacesV1GetEligibilityResponsesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1EpacesV1GetEligibilityResponsesResponse.parseAsync(data),
    url: '/api/v1/services/epaces/eligibility',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1EpacesV1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1EpacesV1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1EpacesV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1EpacesV1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1EpacesV1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/services/epaces/heartbeat',
    ...options
});

export const servicesV1EpacesV1GetPriorAuthorizationResponses = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1EpacesV1GetPriorAuthorizationResponsesData, ThrowOnError>): RequestResult<ServicesV1EpacesV1GetPriorAuthorizationResponsesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1EpacesV1GetPriorAuthorizationResponsesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1EpacesV1GetPriorAuthorizationResponsesResponse.parseAsync(data),
    url: '/api/v1/services/epaces/prior-authorization',
    ...options
});

export const servicesV1EpacesV1GetPriorAuthorizationResponsesForOrder = <ThrowOnError extends boolean = true>(options: Options<ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderData, ThrowOnError>): RequestResult<ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderResponse.parseAsync(data),
    url: '/api/v1/services/epaces/prior-authorization/{order_id}',
    ...options
});

export const servicesV1EpacesV1CancelPriorAuthorizationsForOrder = <ThrowOnError extends boolean = true>(options: Options<ServicesV1EpacesV1CancelPriorAuthorizationsForOrderData, ThrowOnError>): RequestResult<ServicesV1EpacesV1CancelPriorAuthorizationsForOrderResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1EpacesV1CancelPriorAuthorizationsForOrderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1EpacesV1CancelPriorAuthorizationsForOrderResponse.parseAsync(data),
    url: '/api/v1/services/epaces/prior-authorization/{order_id}/cancel',
    ...options
});

export const servicesV1EpacesV1CancelPriorAuthorizationsForOrder2 = <ThrowOnError extends boolean = true>(options: Options<ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Data, ThrowOnError>): RequestResult<ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Response.parseAsync(data),
    url: '/api/v1/services/epaces/prior-authorization/{order_id}/cancel/{hcpc}',
    ...options
});

export const servicesV1EpacesV1SubmitPriorAuthorizationForOrder = <ThrowOnError extends boolean = true>(options: Options<ServicesV1EpacesV1SubmitPriorAuthorizationForOrderData, ThrowOnError>): RequestResult<ServicesV1EpacesV1SubmitPriorAuthorizationForOrderResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1EpacesV1SubmitPriorAuthorizationForOrderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1EpacesV1SubmitPriorAuthorizationForOrderResponse.parseAsync(data),
    url: '/api/v1/services/epaces/prior-authorization/{order_id}/submit',
    ...options
});

export const servicesV1EpacesV1SubmitPriorAuthorizationForOrder2 = <ThrowOnError extends boolean = true>(options: Options<ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Data, ThrowOnError>): RequestResult<ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Response.parseAsync(data),
    url: '/api/v1/services/epaces/prior-authorization/{order_id}/submit/{hcpc}',
    ...options
});

/**
 * Prioritized Order Discovery
 *
 * Run discovery for patient demographics of a given order and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpoint = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/discovery/by-order/prioritized/{order_id}',
    ...options
});

/**
 * Order Discovery
 *
 * Run discovery for patient demographics of a given order
 */
export const servicesV1FrontrunnerV1DiscoveryByOrderEndpoint = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1DiscoveryByOrderEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1DiscoveryByOrderEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1DiscoveryByOrderEndpointResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1DiscoveryByOrderEndpointResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/discovery/by-order/{order_id}',
    ...options
});

/**
 * Patient Discovery
 *
 * Run discovery for supplied patient demographics
 */
export const servicesV1FrontrunnerV1DiscoveryByPatientEndpoint = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1DiscoveryByPatientEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1DiscoveryByPatientEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1FrontrunnerV1DiscoveryByPatientEndpointResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1DiscoveryByPatientEndpointResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/discovery/by-patient',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Prioritized Patient Discovery
 *
 * Run discovery for supplied patient demographics and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpoint = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/discovery/by-patient/prioritized',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Kafka Message to Write FR data to Mongo
 *
 * Generate the message for kafka based on the same output generated by `mongo-discovery-source`
 */
export const getServicesV1FrontrunnerV1MongoDiscoveryEvent = <ThrowOnError extends boolean = true>(options: Options<GetServicesV1FrontrunnerV1MongoDiscoveryEventData, ThrowOnError>): RequestResult<GetServicesV1FrontrunnerV1MongoDiscoveryEventResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetServicesV1FrontrunnerV1MongoDiscoveryEventResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetServicesV1FrontrunnerV1MongoDiscoveryEventResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/discovery/mongo/event/{order_id}',
    ...options
});

/**
 * Generate Kafka Message to Write FR data to Mongo
 *
 * Generate the message for kafka based on the same output generated by `mongo-discovery-source`
 */
export const postServicesV1FrontrunnerV1MongoDiscoveryEvent = <ThrowOnError extends boolean = true>(options: Options<PostServicesV1FrontrunnerV1MongoDiscoveryEventData, ThrowOnError>): RequestResult<PostServicesV1FrontrunnerV1MongoDiscoveryEventResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostServicesV1FrontrunnerV1MongoDiscoveryEventResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPostServicesV1FrontrunnerV1MongoDiscoveryEventResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/discovery/mongo/event/{order_id}',
    ...options
});

/**
 * Generate Order Discovery Source
 *
 * Run discovery for an order and return the source data used to create the frontrunner_discovery event
 */
export const servicesV1FrontrunnerV1MongoDiscoverySource = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1MongoDiscoverySourceData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1MongoDiscoverySourceResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1MongoDiscoverySourceResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1MongoDiscoverySourceResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/discovery/mongo/source/{order_id}',
    ...options
});

/**
 * Prioritized Order Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/eligibility/by-order/prioritized/{order_id}',
    ...options
});

/**
 * Prioritized Order Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2 = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Data, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Response.parseAsync(data),
    url: '/api/v1/services/frontrunner/eligibility/by-order/prioritized/{order_id}/{member_id}',
    ...options
});

/**
 * Order Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order
 */
export const servicesV1FrontrunnerV1EligibilityByOrderEndpoint = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1EligibilityByOrderEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1EligibilityByOrderEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1EligibilityByOrderEndpointResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1EligibilityByOrderEndpointResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/eligibility/by-order/{order_id}',
    ...options
});

/**
 * Order Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order
 */
export const servicesV1FrontrunnerV1EligibilityByOrderEndpoint2 = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Data, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Response.parseAsync(data),
    url: '/api/v1/services/frontrunner/eligibility/by-order/{order_id}/{member_id}',
    ...options
});

/**
 * Patient Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order
 */
export const servicesV1FrontrunnerV1EligibilityByPatientEndpoint = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1EligibilityByPatientEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1EligibilityByPatientEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1FrontrunnerV1EligibilityByPatientEndpointResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1EligibilityByPatientEndpointResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/eligibility/by-patient',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Prioritized Patient Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpoint = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/eligibility/by-patient/prioritized',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Kafka Message to Write FR data to Mongo
 *
 * Generate the message for kafka based on the same output generated by `/eligibility/mongo/source`
 */
export const servicesV1FrontrunnerV1MongoEligibilityEvent = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1MongoEligibilityEventData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1MongoEligibilityEventResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1MongoEligibilityEventResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1MongoEligibilityEventResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/eligibility/mongo/event/{order_id}',
    ...options
});

/**
 * Generate Kafka Message to Write FR data to Mongo
 *
 * Generate the message for kafka based on the same output generated by `/eligibility/mongo/source`
 */
export const servicesV1FrontrunnerV1MongoEligibilityEvent2 = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1MongoEligibilityEvent2Data, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1MongoEligibilityEvent2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1MongoEligibilityEvent2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1MongoEligibilityEvent2Response.parseAsync(data),
    url: '/api/v1/services/frontrunner/eligibility/mongo/event/{order_id}/{member_id}',
    ...options
});

/**
 * Generate Order eligibility Source
 *
 * Run eligibility for an order and return the source data used to create the frontrunner_eligibility event
 */
export const servicesV1FrontrunnerV1MongoEligibilitySource = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1MongoEligibilitySourceData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1MongoEligibilitySourceResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1MongoEligibilitySourceResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1MongoEligibilitySourceResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/eligibility/mongo/source/{order_id}',
    ...options
});

/**
 * Generate Order eligibility Source
 *
 * Run eligibility for an order and return the source data used to create the frontrunner_eligibility event
 */
export const servicesV1FrontrunnerV1MongoEligibilitySource2 = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1MongoEligibilitySource2Data, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1MongoEligibilitySource2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1MongoEligibilitySource2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1MongoEligibilitySource2Response.parseAsync(data),
    url: '/api/v1/services/frontrunner/eligibility/mongo/source/{order_id}/{member_id}',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1FrontrunnerV1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1FrontrunnerV1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1FrontrunnerV1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/heartbeat',
    ...options
});

export const servicesV1FrontrunnerV1MockDiscovery = <ThrowOnError extends boolean = true>(options: Options<ServicesV1FrontrunnerV1MockDiscoveryData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1MockDiscoveryResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1FrontrunnerV1MockDiscoveryResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1FrontrunnerV1MockDiscoveryResponse.parseAsync(data),
    url: '/api/v1/services/frontrunner/mocks/{subpath}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/services/heartbeat',
    ...options
});

/**
 * Retrieve Contact Data
 *
 * Retrieve a list of contacts
 */
export const servicesV1HubspotV1Contacts = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1HubspotV1ContactsData, ThrowOnError>): RequestResult<ServicesV1HubspotV1ContactsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1HubspotV1ContactsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1HubspotV1ContactsResponse.parseAsync(data),
    url: '/api/v1/services/hubspot/contacts',
    ...options
});

export const servicesV1HubspotV1IngestContacts = <ThrowOnError extends boolean = true>(options: Options<ServicesV1HubspotV1IngestContactsData, ThrowOnError>): RequestResult<ServicesV1HubspotV1IngestContactsResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1HubspotV1IngestContactsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1HubspotV1IngestContactsResponse.parseAsync(data),
    url: '/api/v1/services/hubspot/contacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1HubspotV1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1HubspotV1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1HubspotV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1HubspotV1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1HubspotV1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/services/hubspot/heartbeat',
    ...options
});

/**
 * Retrieve Order Data
 *
 * Retrieve a list of orders
 */
export const servicesV1HubspotV1Orders = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1HubspotV1OrdersData, ThrowOnError>): RequestResult<ServicesV1HubspotV1OrdersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1HubspotV1OrdersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1HubspotV1OrdersResponse.parseAsync(data),
    url: '/api/v1/services/hubspot/orders',
    ...options
});

export const servicesV1HubspotV1IngestOrders = <ThrowOnError extends boolean = true>(options: Options<ServicesV1HubspotV1IngestOrdersData, ThrowOnError>): RequestResult<ServicesV1HubspotV1IngestOrdersResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1HubspotV1IngestOrdersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1HubspotV1IngestOrdersResponse.parseAsync(data),
    url: '/api/v1/services/hubspot/orders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve Product Data
 *
 * Retrieve a list of products
 */
export const servicesV1HubspotV1Products = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1HubspotV1ProductsData, ThrowOnError>): RequestResult<ServicesV1HubspotV1ProductsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1HubspotV1ProductsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1HubspotV1ProductsResponse.parseAsync(data),
    url: '/api/v1/services/hubspot/products',
    ...options
});

/**
 * MCP-authorized route to send a reply to an Intercom conversation.
 */
export const servicesV1IntercomV1IntercomSendReply = <ThrowOnError extends boolean = true>(options: Options<ServicesV1IntercomV1IntercomSendReplyData, ThrowOnError>): RequestResult<ServicesV1IntercomV1IntercomSendReplyResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1IntercomV1IntercomSendReplyResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1IntercomV1IntercomSendReplyResponse.parseAsync(data),
    url: '/api/v1/services/intercom/send-reply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1LuminaV1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ServicesV1LuminaV1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1LuminaV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1LuminaV1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1LuminaV1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/services/lumina/heartbeat',
    ...options
});

/**
 * Order Submission to Lumina
 *
 * Kickoff Order Submission to Lumina Data
 */
export const servicesV1LuminaV1SubmitOrder = <ThrowOnError extends boolean = true>(options: Options<ServicesV1LuminaV1SubmitOrderData, ThrowOnError>): RequestResult<ServicesV1LuminaV1SubmitOrderResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1LuminaV1SubmitOrderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1LuminaV1SubmitOrderResponse.parseAsync(data),
    url: '/api/v1/services/lumina/submit-order/{order_id}',
    ...options
});

export const servicesV1SlackV1SlackPost = <ThrowOnError extends boolean = true>(options: Options<ServicesV1SlackV1SlackPostData, ThrowOnError>): RequestResult<ServicesV1SlackV1SlackPostResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1SlackV1SlackPostResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV1SlackV1SlackPostResponse.parseAsync(data),
    url: '/api/v1/services/slack/send-message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all Suppliers
 */
export const suppliersV1GetAllSuppliers = <ThrowOnError extends boolean = true>(options?: Options<SuppliersV1GetAllSuppliersData, ThrowOnError>): RequestResult<SuppliersV1GetAllSuppliersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuppliersV1GetAllSuppliersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSuppliersV1GetAllSuppliersResponse.parseAsync(data),
    url: '/api/v1/suppliers/all',
    ...options
});

/**
 * Details
 *
 * Retrieve the extended Supplier record by uuid
 */
export const suppliersV1Details = <ThrowOnError extends boolean = true>(options: Options<SuppliersV1DetailsData, ThrowOnError>): RequestResult<SuppliersV1DetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SuppliersV1DetailsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSuppliersV1DetailsResponse.parseAsync(data),
    url: '/api/v1/suppliers/details/{supplier_id}',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const suppliersV1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<SuppliersV1HeartbeatData, ThrowOnError>): RequestResult<SuppliersV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuppliersV1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSuppliersV1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/suppliers/heartbeat',
    ...options
});

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const suppliersV1Search = <ThrowOnError extends boolean = true>(options?: Options<SuppliersV1SearchData, ThrowOnError>): RequestResult<SuppliersV1SearchResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuppliersV1SearchResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSuppliersV1SearchResponse.parseAsync(data),
    url: '/api/v1/suppliers/search',
    ...options
});

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const suppliersV1Search2 = <ThrowOnError extends boolean = true>(options: Options<SuppliersV1Search2Data, ThrowOnError>): RequestResult<SuppliersV1Search2Responses, unknown, ThrowOnError> => (options.client ?? client).get<SuppliersV1Search2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSuppliersV1Search2Response.parseAsync(data),
    url: '/api/v1/suppliers/search/{category}',
    ...options
});

/**
 * Sync Aggregate Legacy Contacts
 *
 * Regenerate contents of AggregateLegacyContacts Table
 */
export const systemV1AggregateLegacyContacts = <ThrowOnError extends boolean = true>(options?: Options<SystemV1AggregateLegacyContactsData, ThrowOnError>): RequestResult<SystemV1AggregateLegacyContactsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1AggregateLegacyContactsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1AggregateLegacyContactsResponse.parseAsync(data),
    url: '/api/v1/system/aggregate-legacy-contacts',
    ...options
});

export const systemV1AnalyzeProgressNoteRoute = <ThrowOnError extends boolean = true>(options: Options<SystemV1AnalyzeProgressNoteRouteData, ThrowOnError>): RequestResult<SystemV1AnalyzeProgressNoteRouteResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1AnalyzeProgressNoteRouteResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zSystemV1AnalyzeProgressNoteRouteResponse.parseAsync(data),
    url: '/api/v1/system/analyze-progress-note',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Axiom Bot Status
 *
 * Query the bot's status endpoint
 */
export const systemV1AxiomStatus = <ThrowOnError extends boolean = true>(options?: Options<SystemV1AxiomStatusData, ThrowOnError>): RequestResult<SystemV1AxiomStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1AxiomStatusResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1AxiomStatusResponse.parseAsync(data),
    url: '/api/v1/system/axiom-status',
    ...options
});

/**
 * Clear Axiom Mutex
 *
 * Clear the Axiom Mutex if it is equal to a specific Order #
 */
export const systemV1ClearAxiom = <ThrowOnError extends boolean = true>(options: Options<SystemV1ClearAxiomData, ThrowOnError>): RequestResult<SystemV1ClearAxiomResponses, unknown, ThrowOnError> => (options.client ?? client).get<SystemV1ClearAxiomResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1ClearAxiomResponse.parseAsync(data),
    url: '/api/v1/system/clear-axiom-mutex/{order_id}',
    ...options
});

/**
 * Queue conversion events for server-side attribution tracking.
 */
export const systemV1MessageConversionEvents = <ThrowOnError extends boolean = true>(options: Options<SystemV1MessageConversionEventsData, ThrowOnError>): RequestResult<SystemV1MessageConversionEventsResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1MessageConversionEventsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1MessageConversionEventsResponse.parseAsync(data),
    url: '/api/v1/system/conversion-events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Current Axiom Mutex
 *
 * Display the contents of the current axiom mutex
 */
export const systemV1CurrentAxiom = <ThrowOnError extends boolean = true>(options?: Options<SystemV1CurrentAxiomData, ThrowOnError>): RequestResult<SystemV1CurrentAxiomResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1CurrentAxiomResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1CurrentAxiomResponse.parseAsync(data),
    url: '/api/v1/system/current-axiom-mutex',
    ...options
});

/**
 * Disable Current Axiom Order
 *
 * Disable the current axiom order and clear the mutex
 */
export const systemV1DisableCurrentAxiomOrder = <ThrowOnError extends boolean = true>(options: Options<SystemV1DisableCurrentAxiomOrderData, ThrowOnError>): RequestResult<SystemV1DisableCurrentAxiomOrderResponses, unknown, ThrowOnError> => (options.client ?? client).get<SystemV1DisableCurrentAxiomOrderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1DisableCurrentAxiomOrderResponse.parseAsync(data),
    url: '/api/v1/system/disable-current-axiom-order/{order_id}',
    ...options
});

/**
 * EPaces
 *
 * Display the contents of an epaces form
 */
export const systemV1Epaces = <ThrowOnError extends boolean = true>(options?: Options<SystemV1EpacesData, ThrowOnError>): RequestResult<SystemV1EpacesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1EpacesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1EpacesResponse.parseAsync(data),
    url: '/api/v1/system/epaces',
    ...options
});

export const systemV1GenerateLomnRoute = <ThrowOnError extends boolean = true>(options: Options<SystemV1GenerateLomnRouteData, ThrowOnError>): RequestResult<SystemV1GenerateLomnRouteResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1GenerateLomnRouteResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zSystemV1GenerateLomnRouteResponse.parseAsync(data),
    url: '/api/v1/system/generate-lomn',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const systemV1Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<SystemV1HeartbeatData, ThrowOnError>): RequestResult<SystemV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1HeartbeatResponse.parseAsync(data),
    url: '/api/v1/system/heartbeat',
    ...options
});

/**
 * Generate Kafka Message
 *
 * Generate an arbitrary message to the indicated topic
 */
export const systemV1ProduceMessage = <ThrowOnError extends boolean = true>(options: Options<SystemV1ProduceMessageData, ThrowOnError>): RequestResult<SystemV1ProduceMessageResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1ProduceMessageResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1ProduceMessageResponse.parseAsync(data),
    url: '/api/v1/system/kafka-message/{topic}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const systemV1LomnHistory = <ThrowOnError extends boolean = true>(options: Options<SystemV1LomnHistoryData, ThrowOnError>): RequestResult<SystemV1LomnHistoryResponses, unknown, ThrowOnError> => (options.client ?? client).get<SystemV1LomnHistoryResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1LomnHistoryResponse.parseAsync(data),
    url: '/api/v1/system/lomn-history/{order_id}',
    ...options
});

export const systemV1LomnPdf = <ThrowOnError extends boolean = true>(options: Options<SystemV1LomnPdfData, ThrowOnError>): RequestResult<SystemV1LomnPdfResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1LomnPdfResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1LomnPdfResponse.parseAsync(data),
    url: '/api/v1/system/lomn-pdf/{order_id}',
    ...options
});

export const systemV1LomnRequirements = <ThrowOnError extends boolean = true>(options: Options<SystemV1LomnRequirementsData, ThrowOnError>): RequestResult<SystemV1LomnRequirementsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SystemV1LomnRequirementsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1LomnRequirementsResponse.parseAsync(data),
    url: '/api/v1/system/lomn-requirements/{order_id}',
    ...options
});

/**
 * Migrate legacy MySQL patient data into Postgres.
 *
 * Kicks off a Celery task that creates Patient, OrgPatient, Address, Contact,
 * OrgPatientAddress, OrgPatientContact, and OrgPatientInsurance from legacy
 * patient/address/contact/insurance tables. Legacy patient's own contact
 * info becomes a Contact with OrgPatientContact patient_relationship="self".
 *
 * Query params (optional):
 * single_batch: if truthy (e.g. ?single_batch=1), run only one batch of 500.
 */
export const systemV1MigrateLegacyPatientsRoute = <ThrowOnError extends boolean = true>(options?: Options<SystemV1MigrateLegacyPatientsRouteData, ThrowOnError>): RequestResult<SystemV1MigrateLegacyPatientsRouteResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1MigrateLegacyPatientsRouteResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1MigrateLegacyPatientsRouteResponse.parseAsync(data),
    url: '/api/v1/system/migrate-legacy-patients',
    ...options
});

/**
 * Migrate Mongo orders into Postgres orders bind tables.
 *
 * Celery task reads legacy Mongo orders in batches, inserts into ``orders`` (and
 * related physician / address rows). Skips rows already present (unique
 * ``orders.legacy_id``).
 *
 * Query params (optional):
 * single_batch: if truthy (e.g. ?single_batch=1), run only one batch of 500.
 * starting_mongo_order_id: integer; first batch loads Mongo orders with
 * ``order_id >=`` this value, then continues in batches of 500 by ascending id.
 */
export const systemV1MigrateMongoOrdersRoute = <ThrowOnError extends boolean = true>(options?: Options<SystemV1MigrateMongoOrdersRouteData, ThrowOnError>): RequestResult<SystemV1MigrateMongoOrdersRouteResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1MigrateMongoOrdersRouteResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1MigrateMongoOrdersRouteResponse.parseAsync(data),
    url: '/api/v1/system/migrate-mongo-orders',
    ...options
});

export const systemV1MongoHealth = <ThrowOnError extends boolean = true>(options?: Options<SystemV1MongoHealthData, ThrowOnError>): RequestResult<SystemV1MongoHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1MongoHealthResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1MongoHealthResponse.parseAsync(data),
    url: '/api/v1/system/mongo/health',
    ...options
});

export const systemV1ListOrderedTables = <ThrowOnError extends boolean = true>(options?: Options<SystemV1ListOrderedTablesData, ThrowOnError>): RequestResult<SystemV1ListOrderedTablesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1ListOrderedTablesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1ListOrderedTablesResponse.parseAsync(data),
    url: '/api/v1/system/ordered-tables',
    ...options
});

export const systemV1ListOrderedTables2 = <ThrowOnError extends boolean = true>(options: Options<SystemV1ListOrderedTables2Data, ThrowOnError>): RequestResult<SystemV1ListOrderedTables2Responses, unknown, ThrowOnError> => (options.client ?? client).get<SystemV1ListOrderedTables2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1ListOrderedTables2Response.parseAsync(data),
    url: '/api/v1/system/ordered-tables/{pattern}',
    ...options
});

export const systemV1PdfReader = <ThrowOnError extends boolean = true>(options: Options<SystemV1PdfReaderData, ThrowOnError>): RequestResult<SystemV1PdfReaderResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1PdfReaderResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zSystemV1PdfReaderResponse.parseAsync(data),
    url: '/api/v1/system/pdf-reader',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Re-sync Mongo orders into Postgres by integer ``order_id``.
 *
 * Celery task loads current Mongo documents and upserts ``orders`` and related
 * rows (same as the batch migrator). Use when documents changed after the
 * initial migration. At most 100 ids per request.
 *
 * JSON body:
 * mongo_order_ids: required list of Mongo order ids, e.g. ``{"mongo_order_ids": [1, 2, 3]}``.
 */
export const systemV1SyncMongoOrdersById = <ThrowOnError extends boolean = true>(options: Options<SystemV1SyncMongoOrdersByIdData, ThrowOnError>): RequestResult<SystemV1SyncMongoOrdersByIdResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1SyncMongoOrdersByIdResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1SyncMongoOrdersByIdResponse.parseAsync(data),
    url: '/api/v1/system/sync-mongo-orders-by-id',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const systemV1TriggerResupplyReport = <ThrowOnError extends boolean = true>(options?: Options<SystemV1TriggerResupplyReportData, ThrowOnError>): RequestResult<SystemV1TriggerResupplyReportResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1TriggerResupplyReportResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSystemV1TriggerResupplyReportResponse.parseAsync(data),
    url: '/api/v1/system/trigger-resupply-report',
    ...options
});

export const usersV1CreateUser = <ThrowOnError extends boolean = true>(options: Options<UsersV1CreateUserData, ThrowOnError>): RequestResult<UsersV1CreateUserResponses, unknown, ThrowOnError> => (options.client ?? client).post<UsersV1CreateUserResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersV1CreateUserResponse.parseAsync(data),
    url: '/api/v1/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const usersV1ActivateUser = <ThrowOnError extends boolean = true>(options: Options<UsersV1ActivateUserData, ThrowOnError>): RequestResult<UsersV1ActivateUserResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UsersV1ActivateUserResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersV1ActivateUserResponse.parseAsync(data),
    url: '/api/v1/users/activate/{user_id}',
    ...options
});

export const usersV1SearchUsers = <ThrowOnError extends boolean = true>(options?: Options<UsersV1SearchUsersData, ThrowOnError>): RequestResult<UsersV1SearchUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersV1SearchUsersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersV1SearchUsersResponse.parseAsync(data),
    url: '/api/v1/users/search',
    ...options
});

export const usersV1DeleteUser = <ThrowOnError extends boolean = true>(options: Options<UsersV1DeleteUserData, ThrowOnError>): RequestResult<UsersV1DeleteUserResponses, unknown, ThrowOnError> => (options.client ?? client).delete<UsersV1DeleteUserResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersV1DeleteUserResponse.parseAsync(data),
    url: '/api/v1/users/{user_id}',
    ...options
});

export const usersV1GetUser = <ThrowOnError extends boolean = true>(options: Options<UsersV1GetUserData, ThrowOnError>): RequestResult<UsersV1GetUserResponses, unknown, ThrowOnError> => (options.client ?? client).get<UsersV1GetUserResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersV1GetUserResponse.parseAsync(data),
    url: '/api/v1/users/{user_id}',
    ...options
});

export const usersV1UpdateUser = <ThrowOnError extends boolean = true>(options: Options<UsersV1UpdateUserData, ThrowOnError>): RequestResult<UsersV1UpdateUserResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UsersV1UpdateUserResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersV1UpdateUserResponse.parseAsync(data),
    url: '/api/v1/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get list of carriers for a given state
 */
export const insuranceV2GetCarriersByState = <ThrowOnError extends boolean = true>(options: Options<InsuranceV2GetCarriersByStateData, ThrowOnError>): RequestResult<InsuranceV2GetCarriersByStateResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2GetCarriersByStateResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV2GetCarriersByStateResponse.parseAsync(data),
    url: '/api/v2/insurance/carriers/{state}',
    ...options
});

/**
 * Get all CoverageZones
 */
export const insuranceV2GetCoverageZones = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV2GetCoverageZonesData, ThrowOnError>): RequestResult<InsuranceV2GetCoverageZonesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV2GetCoverageZonesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV2GetCoverageZonesResponse.parseAsync(data),
    url: '/api/v2/insurance/coverage_zones/all',
    ...options
});

/**
 * Refills
 *
 * Retrieve the max refills Insurance record by product code(s) and insurance carrier
 */
export const insuranceV2Refills = <ThrowOnError extends boolean = true>(options: Options<InsuranceV2RefillsData, ThrowOnError>): RequestResult<InsuranceV2RefillsResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2RefillsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV2RefillsResponse.parseAsync(data),
    url: '/api/v2/insurance/fee_schedule/{carrier}/{state}',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const insuranceV2Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV2HeartbeatData, ThrowOnError>): RequestResult<InsuranceV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV2HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV2HeartbeatResponse.parseAsync(data),
    url: '/api/v2/insurance/heartbeat',
    ...options
});

export const insuranceV2SearchIcds = <ThrowOnError extends boolean = true>(options: Options<InsuranceV2SearchIcdsData, ThrowOnError>): RequestResult<InsuranceV2SearchIcdsResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2SearchIcdsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV2SearchIcdsResponse.parseAsync(data),
    url: '/api/v2/insurance/icds/search',
    ...options
});

export const insuranceV2GetPrimaryIcds = <ThrowOnError extends boolean = true>(options: Options<InsuranceV2GetPrimaryIcdsData, ThrowOnError>): RequestResult<InsuranceV2GetPrimaryIcdsResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2GetPrimaryIcdsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV2GetPrimaryIcdsResponse.parseAsync(data),
    url: '/api/v2/insurance/icds/{hcpc}/qualifying',
    ...options
});

/**
 * Get product details for a given carrier & state using a legacy id
 */
export const insuranceV2GetCarrierProductLegacy = <ThrowOnError extends boolean = true>(options: Options<InsuranceV2GetCarrierProductLegacyData, ThrowOnError>): RequestResult<InsuranceV2GetCarrierProductLegacyResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2GetCarrierProductLegacyResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV2GetCarrierProductLegacyResponse.parseAsync(data),
    url: '/api/v2/insurance/{carrier}/{state}/legacy_product/{legacy_product_id}',
    ...options
});

/**
 * Get via Carrier/State
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV2GetCarrierProduct = <ThrowOnError extends boolean = true>(options: Options<InsuranceV2GetCarrierProductData, ThrowOnError>): RequestResult<InsuranceV2GetCarrierProductResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2GetCarrierProductResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV2GetCarrierProductResponse.parseAsync(data),
    url: '/api/v2/insurance/{carrier}/{state}/product/{carrier_coverage_product_uuid}',
    ...options
});

/**
 * Get via Carrier/State
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV2GetCarrierProducts = <ThrowOnError extends boolean = true>(options: Options<InsuranceV2GetCarrierProductsData, ThrowOnError>): RequestResult<InsuranceV2GetCarrierProductsResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2GetCarrierProductsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV2GetCarrierProductsResponse.parseAsync(data),
    url: '/api/v2/insurance/{carrier}/{state}/products',
    ...options
});

export const npiV2SearchProviders = <ThrowOnError extends boolean = true>(options?: Options<NpiV2SearchProvidersData, ThrowOnError>): RequestResult<NpiV2SearchProvidersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<NpiV2SearchProvidersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zNpiV2SearchProvidersResponse.parseAsync(data),
    url: '/api/v2/npi/search',
    ...options
});

export const npiV2GetProvider = <ThrowOnError extends boolean = true>(options: Options<NpiV2GetProviderData, ThrowOnError>): RequestResult<NpiV2GetProviderResponses, unknown, ThrowOnError> => (options.client ?? client).get<NpiV2GetProviderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zNpiV2GetProviderResponse.parseAsync(data),
    url: '/api/v2/npi/{npi}',
    ...options
});

export const npiV2UpdateProvider = <ThrowOnError extends boolean = true>(options: Options<NpiV2UpdateProviderData, ThrowOnError>): RequestResult<NpiV2UpdateProviderResponses, unknown, ThrowOnError> => (options.client ?? client).patch<NpiV2UpdateProviderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zNpiV2UpdateProviderResponse.parseAsync(data),
    url: '/api/v2/npi/{npi}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const npiV2AddProviderAddress = <ThrowOnError extends boolean = true>(options: Options<NpiV2AddProviderAddressData, ThrowOnError>): RequestResult<NpiV2AddProviderAddressResponses, unknown, ThrowOnError> => (options.client ?? client).post<NpiV2AddProviderAddressResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zNpiV2AddProviderAddressResponse.parseAsync(data),
    url: '/api/v2/npi/{npi}/addresses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const npiV2UpdateProviderAddress = <ThrowOnError extends boolean = true>(options: Options<NpiV2UpdateProviderAddressData, ThrowOnError>): RequestResult<NpiV2UpdateProviderAddressResponses, unknown, ThrowOnError> => (options.client ?? client).patch<NpiV2UpdateProviderAddressResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zNpiV2UpdateProviderAddressResponse.parseAsync(data),
    url: '/api/v2/npi/{npi}/addresses/{address_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const npiV2ToggleProviderAddress = <ThrowOnError extends boolean = true>(options: Options<NpiV2ToggleProviderAddressData, ThrowOnError>): RequestResult<NpiV2ToggleProviderAddressResponses, unknown, ThrowOnError> => (options.client ?? client).patch<NpiV2ToggleProviderAddressResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zNpiV2ToggleProviderAddressResponse.parseAsync(data),
    url: '/api/v2/npi/{npi}/addresses/{address_uuid}/toggle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Return the list of all valid V2 order statuses.
 *
 * Migrated from orders GraphQL query: getOrderStatusesV2
 */
export const ordersV2GetOrderStatusesV2 = <ThrowOnError extends boolean = true>(options?: Options<OrdersV2GetOrderStatusesV2Data, ThrowOnError>): RequestResult<OrdersV2GetOrderStatusesV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV2GetOrderStatusesV2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2GetOrderStatusesV2Response.parseAsync(data),
    url: '/api/v2/orders/statuses',
    ...options
});

/**
 * Move order to BILLING state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToBilling
 */
export const ordersV2MoveOrderToBilling = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToBillingData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToBillingResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToBillingResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToBillingResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/billing',
    ...options
});

/**
 * Move order to CANT_REACH_PATIENT state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToCantReachPatient
 */
export const ordersV2MoveOrderToCantReachPatient = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToCantReachPatientData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToCantReachPatientResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToCantReachPatientResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToCantReachPatientResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/cant-reach-patient',
    ...options
});

/**
 * Move order to DONE state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToDone
 */
export const ordersV2MoveOrderToDone = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToDoneData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToDoneResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToDoneResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToDoneResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/done',
    ...options
});

/**
 * Duplicate an order (e.g. for resupply). Returns the new order's id and status.
 *
 * The duplicate_order utility internally emits ORDERS_REPLICATE_HISTORY_V1 and
 * ORDERS_ORDER_COPY_FILES_V1 so downstream services copy history and files onto
 * the new order.
 *
 * Migrated from orders GraphQL mutation: duplicateOrder (V2)
 */
export const ordersV2DuplicateOrderV2 = <ThrowOnError extends boolean = true>(options: Options<OrdersV2DuplicateOrderV2Data, ThrowOnError>): RequestResult<OrdersV2DuplicateOrderV2Responses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV2DuplicateOrderV2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2DuplicateOrderV2Response.parseAsync(data),
    url: '/api/v2/orders/{order_id}/duplicate',
    ...options
});

/**
 * Move order to IN_PROGRESS_WITH_SUPPLIER state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToInProgressWithSupplier
 */
export const ordersV2MoveOrderToInProgressWithSupplier = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToInProgressWithSupplierData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToInProgressWithSupplierResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToInProgressWithSupplierResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToInProgressWithSupplierResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/in-progress-with-supplier',
    ...options
});

/**
 * Move order to ON_HOLD_WITH_SUPPLIER state with a required reason.
 *
 * Migrated from orders GraphQL mutation: moveOrderToOnHoldWithSupplier
 */
export const ordersV2MoveOrderToOnHoldWithSupplier = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToOnHoldWithSupplierData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToOnHoldWithSupplierResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToOnHoldWithSupplierResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToOnHoldWithSupplierResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/on-hold-with-supplier',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move order to PENDING_AUTHORIZATION state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToPendingAuthorization
 */
export const ordersV2MoveOrderToPendingAuthorization = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToPendingAuthorizationData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToPendingAuthorizationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToPendingAuthorizationResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToPendingAuthorizationResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/pending-authorization',
    ...options
});

/**
 * Move order to PENDING_REROUTE state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToPendingReroute
 */
export const ordersV2MoveOrderToPendingReroute = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToPendingRerouteData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToPendingRerouteResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToPendingRerouteResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToPendingRerouteResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/pending-reroute',
    ...options
});

/**
 * Move order to PENDING_ACCEPTANCE state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToPendingSupplierAcceptance
 *
 * RX Date gate: when the order's supplier has ``require_rx_date_gate=True``
 * and the order has ``prescription_metadata`` present (not grandfathered),
 * the metadata must include a non-None ``expiration_date`` before the
 * transition is allowed.
 */
export const ordersV2MoveOrderToPendingSupplierAcceptance = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToPendingSupplierAcceptanceData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToPendingSupplierAcceptanceResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToPendingSupplierAcceptanceResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToPendingSupplierAcceptanceResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/pending-supplier-acceptance',
    ...options
});

/**
 * Move order to PREPARING_SHIPMENT state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToPreparingShipment
 */
export const ordersV2MoveOrderToPreparingShipment = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToPreparingShipmentData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToPreparingShipmentResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToPreparingShipmentResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToPreparingShipmentResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/preparing-shipment',
    ...options
});

/**
 * Request a refresh of the e-signature for an order.
 *
 * Validates that:
 * - The order has an e-signature
 * - The e-signature is not already signed
 * - The e-signature link has expired (created more than 24 hours ago)
 *
 * Migrated from orders GraphQL mutation: refreshEsignature
 */
export const ordersV2RefreshEsignature = <ThrowOnError extends boolean = true>(options: Options<OrdersV2RefreshEsignatureData, ThrowOnError>): RequestResult<OrdersV2RefreshEsignatureResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2RefreshEsignatureResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2RefreshEsignatureResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/refresh-esignature',
    ...options
});

/**
 * Request an e-signature for an order by uploading a document.
 *
 * Proxies the file upload to the esignature service.  MongoDB write is a
 * placeholder pending full migration.
 *
 * Migrated from orders service: POST /orders/api/esignature/request
 */
export const ordersV2RequestEsignature = <ThrowOnError extends boolean = true>(options: Options<OrdersV2RequestEsignatureData, ThrowOnError>): RequestResult<OrdersV2RequestEsignatureResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV2RequestEsignatureResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zOrdersV2RequestEsignatureResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/request-esignature',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Move order to SUPPLIER_COMPLETED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToSupplierCompleted
 */
export const ordersV2MoveOrderToSupplierCompleted = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToSupplierCompletedData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToSupplierCompletedResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToSupplierCompletedResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToSupplierCompletedResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/supplier-completed',
    ...options
});

/**
 * Move order to SUPPLIER_SHIPPED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToSupplierShipped
 */
export const ordersV2MoveOrderToSupplierShipped = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToSupplierShippedData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToSupplierShippedResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToSupplierShippedResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToSupplierShippedResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/supplier-shipped',
    ...options
});

/**
 * Move order to CHASING_CLINICALS state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthChasingClinicals
 */
export const ordersV2MoveOrderToTelehealthChasingClinicals = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToTelehealthChasingClinicalsData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthChasingClinicalsResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthChasingClinicalsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToTelehealthChasingClinicalsResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/telehealth-chasing-clinicals',
    ...options
});

/**
 * Move order to TELEHEALTH_COMPLETED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthCompleted (V2)
 */
export const ordersV2MoveOrderToTelehealthCompleted = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToTelehealthCompletedData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthCompletedResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthCompletedResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToTelehealthCompletedResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/telehealth-completed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move order to CONTACTING_PATIENT state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthContactingPatient
 */
export const ordersV2MoveOrderToTelehealthContactingPatient = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToTelehealthContactingPatientData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthContactingPatientResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthContactingPatientResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToTelehealthContactingPatientResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/telehealth-contacting-patient',
    ...options
});

/**
 * Move order to TELEHEALTH_NEEDS_RESCHED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthNeedsResched
 */
export const ordersV2MoveOrderToTelehealthNeedsRescheduling = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToTelehealthNeedsReschedulingData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthNeedsReschedulingResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthNeedsReschedulingResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToTelehealthNeedsReschedulingResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/telehealth-needs-rescheduling',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move order to TELEHEALTH_ON_HOLD state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthOnHold
 */
export const ordersV2MoveOrderToTelehealthOnHold = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToTelehealthOnHoldData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthOnHoldResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthOnHoldResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToTelehealthOnHoldResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/telehealth-on-hold',
    ...options
});

/**
 * Move order to POST_VISIT_ACTIONS_COMPLETED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthPostVisitActionsCompleted
 */
export const ordersV2MoveOrderToTelehealthPostVisitCompleted = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToTelehealthPostVisitCompletedData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthPostVisitCompletedResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthPostVisitCompletedResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToTelehealthPostVisitCompletedResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/telehealth-post-visit-completed',
    ...options
});

/**
 * Move order to TELEHEALTH_UPCOMING state with a scheduled appointment time.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthUpcoming
 */
export const ordersV2MoveOrderToTelehealthUpcoming = <ThrowOnError extends boolean = true>(options: Options<OrdersV2MoveOrderToTelehealthUpcomingData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthUpcomingResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthUpcomingResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV2MoveOrderToTelehealthUpcomingResponse.parseAsync(data),
    url: '/api/v2/orders/{order_id}/telehealth-upcoming',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const patientsV2Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<PatientsV2HeartbeatData, ThrowOnError>): RequestResult<PatientsV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PatientsV2HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPatientsV2HeartbeatResponse.parseAsync(data),
    url: '/api/v2/patients/heartbeat',
    ...options
});

/**
 * Patient Search
 *
 * Get list of patients by case-insensitive partial match against
 * - First Name
 * - Last Name
 * - Email
 * - Auth0 ID
 */
export const patientsV2SearchPatients = <ThrowOnError extends boolean = true>(options?: Options<PatientsV2SearchPatientsData, ThrowOnError>): RequestResult<PatientsV2SearchPatientsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PatientsV2SearchPatientsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPatientsV2SearchPatientsResponse.parseAsync(data),
    url: '/api/v2/patients/search',
    ...options
});

/**
 * Patient Detail
 *
 * Get patient details by numeric id
 */
export const patientsV2PatientDetails = <ThrowOnError extends boolean = true>(options: Options<PatientsV2PatientDetailsData, ThrowOnError>): RequestResult<PatientsV2PatientDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<PatientsV2PatientDetailsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPatientsV2PatientDetailsResponse.parseAsync(data),
    url: '/api/v2/patients/{patient_id}',
    ...options
});

/**
 * Patient Detail
 *
 * Get patient address details by numeric id
 */
export const patientsV2PatientAddresses = <ThrowOnError extends boolean = true>(options: Options<PatientsV2PatientAddressesData, ThrowOnError>): RequestResult<PatientsV2PatientAddressesResponses, unknown, ThrowOnError> => (options.client ?? client).get<PatientsV2PatientAddressesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPatientsV2PatientAddressesResponse.parseAsync(data),
    url: '/api/v2/patients/{patient_id}/addresses',
    ...options
});

/**
 * Patient Detail
 *
 * Get patient contacts details by numeric id
 */
export const patientsV2PatientContacts = <ThrowOnError extends boolean = true>(options: Options<PatientsV2PatientContactsData, ThrowOnError>): RequestResult<PatientsV2PatientContactsResponses, unknown, ThrowOnError> => (options.client ?? client).get<PatientsV2PatientContactsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPatientsV2PatientContactsResponse.parseAsync(data),
    url: '/api/v2/patients/{patient_id}/contacts',
    ...options
});

/**
 * Patient Detail
 *
 * Get patient insurance details by numeric id
 */
export const patientsV2PatientInsurances = <ThrowOnError extends boolean = true>(options: Options<PatientsV2PatientInsurancesData, ThrowOnError>): RequestResult<PatientsV2PatientInsurancesResponses, unknown, ThrowOnError> => (options.client ?? client).get<PatientsV2PatientInsurancesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPatientsV2PatientInsurancesResponse.parseAsync(data),
    url: '/api/v2/patients/{patient_id}/insurances',
    ...options
});

/**
 * Patient Detail
 *
 * Get patient details by numeric id
 */
export const patientsV2PatientOrders = <ThrowOnError extends boolean = true>(options: Options<PatientsV2PatientOrdersData, ThrowOnError>): RequestResult<PatientsV2PatientOrdersResponses, unknown, ThrowOnError> => (options.client ?? client).get<PatientsV2PatientOrdersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPatientsV2PatientOrdersResponse.parseAsync(data),
    url: '/api/v2/patients/{patient_id}/orders',
    ...options
});

export const patientsV2ReassignPatient = <ThrowOnError extends boolean = true>(options: Options<PatientsV2ReassignPatientData, ThrowOnError>): RequestResult<PatientsV2ReassignPatientResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatientsV2ReassignPatientResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPatientsV2ReassignPatientResponse.parseAsync(data),
    url: '/api/v2/patients/{patient_id}/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a Carrier Coverage Zone Product
 */
export const productsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProduct = <ThrowOnError extends boolean = true>(options: Options<ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductData, ThrowOnError>): RequestResult<ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductResponse.parseAsync(data),
    url: '/api/v2/products/carrier_coverage_zone_products/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const productsV2CarrierCoverageZoneProductsV2Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ProductsV2CarrierCoverageZoneProductsV2HeartbeatData, ThrowOnError>): RequestResult<ProductsV2CarrierCoverageZoneProductsV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2CarrierCoverageZoneProductsV2HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2CarrierCoverageZoneProductsV2HeartbeatResponse.parseAsync(data),
    url: '/api/v2/products/carrier_coverage_zone_products/heartbeat',
    ...options
});

/**
 * Get Carrier Coverage Zone Product by uuid
 */
export const productsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetails = <ThrowOnError extends boolean = true>(options: Options<ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsData, ThrowOnError>): RequestResult<ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsResponse.parseAsync(data),
    url: '/api/v2/products/carrier_coverage_zone_products/{uuid}',
    ...options
});

/**
 * Delete a Carrier Coverage Zone Product
 */
export const productsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProduct = <ThrowOnError extends boolean = true>(options: Options<ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductData, ThrowOnError>): RequestResult<ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductResponse.parseAsync(data),
    url: '/api/v2/products/carrier_coverage_zone_products/{uuid}/delete',
    ...options
});

/**
 * Edit a Carrier Coverage Zone Product
 */
export const productsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProduct = <ThrowOnError extends boolean = true>(options: Options<ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductData, ThrowOnError>): RequestResult<ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductResponses, unknown, ThrowOnError> => (options.client ?? client).put<ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductResponse.parseAsync(data),
    url: '/api/v2/products/carrier_coverage_zone_products/{uuid}/edit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const productsV2CartV2DeleteCart = <ThrowOnError extends boolean = true>(options?: Options<ProductsV2CartV2DeleteCartData, ThrowOnError>): RequestResult<ProductsV2CartV2DeleteCartResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<ProductsV2CartV2DeleteCartResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2CartV2DeleteCartResponse.parseAsync(data),
    url: '/api/v2/products/cart',
    ...options
});

export const productsV2CartV2GetCart = <ThrowOnError extends boolean = true>(options?: Options<ProductsV2CartV2GetCartData, ThrowOnError>): RequestResult<ProductsV2CartV2GetCartResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2CartV2GetCartResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2CartV2GetCartResponse.parseAsync(data),
    url: '/api/v2/products/cart',
    ...options
});

export const postProductsV2CartV2CreateUpdateCart = <ThrowOnError extends boolean = true>(options: Options<PostProductsV2CartV2CreateUpdateCartData, ThrowOnError>): RequestResult<PostProductsV2CartV2CreateUpdateCartResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostProductsV2CartV2CreateUpdateCartResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPostProductsV2CartV2CreateUpdateCartResponse.parseAsync(data),
    url: '/api/v2/products/cart',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putProductsV2CartV2CreateUpdateCart = <ThrowOnError extends boolean = true>(options: Options<PutProductsV2CartV2CreateUpdateCartData, ThrowOnError>): RequestResult<PutProductsV2CartV2CreateUpdateCartResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutProductsV2CartV2CreateUpdateCartResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPutProductsV2CartV2CreateUpdateCartResponse.parseAsync(data),
    url: '/api/v2/products/cart',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all Product Categories
 */
export const productsV2CategoriesV2GetAllCategories = <ThrowOnError extends boolean = true>(options?: Options<ProductsV2CategoriesV2GetAllCategoriesData, ThrowOnError>): RequestResult<ProductsV2CategoriesV2GetAllCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2CategoriesV2GetAllCategoriesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2CategoriesV2GetAllCategoriesResponse.parseAsync(data),
    url: '/api/v2/products/categories/all',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV2CategoriesV2Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ProductsV2CategoriesV2HeartbeatData, ThrowOnError>): RequestResult<ProductsV2CategoriesV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2CategoriesV2HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2CategoriesV2HeartbeatResponse.parseAsync(data),
    url: '/api/v2/products/categories/heartbeat',
    ...options
});

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const productsV2CategoriesV2SearchCategories = <ThrowOnError extends boolean = true>(options?: Options<ProductsV2CategoriesV2SearchCategoriesData, ThrowOnError>): RequestResult<ProductsV2CategoriesV2SearchCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2CategoriesV2SearchCategoriesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2CategoriesV2SearchCategoriesResponse.parseAsync(data),
    url: '/api/v2/products/categories/search',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV2Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ProductsV2HeartbeatData, ThrowOnError>): RequestResult<ProductsV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2HeartbeatResponse.parseAsync(data),
    url: '/api/v2/products/heartbeat',
    ...options
});

/**
 * Search through Products with filters for CoverageZone, Supplier, Category, and a search term.
 *
 * Filters for CoverageZone and Supplier apply to the product's CarrierCoverageZoneProduct. If any
 * of a products CarrierCoverageZoneProducts match those filters, the parent Product is included in the results.
 */
export const productsV2SearchProducts = <ThrowOnError extends boolean = true>(options?: Options<ProductsV2SearchProductsData, ThrowOnError>): RequestResult<ProductsV2SearchProductsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2SearchProductsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2SearchProductsResponse.parseAsync(data),
    url: '/api/v2/products/search',
    ...options
});

export const productsV2FoldProducts = <ThrowOnError extends boolean = true>(options: Options<ProductsV2FoldProductsData, ThrowOnError>): RequestResult<ProductsV2FoldProductsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV2FoldProductsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2FoldProductsResponse.parseAsync(data),
    url: '/api/v2/products/{product_uuid}/test',
    ...options
});

export const productsV2FoldProducts2 = <ThrowOnError extends boolean = true>(options: Options<ProductsV2FoldProducts2Data, ThrowOnError>): RequestResult<ProductsV2FoldProducts2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV2FoldProducts2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2FoldProducts2Response.parseAsync(data),
    url: '/api/v2/products/{product_uuid}/test/all/{state}',
    ...options
});

export const productsV2FoldProducts3 = <ThrowOnError extends boolean = true>(options: Options<ProductsV2FoldProducts3Data, ThrowOnError>): RequestResult<ProductsV2FoldProducts3Responses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV2FoldProducts3Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2FoldProducts3Response.parseAsync(data),
    url: '/api/v2/products/{product_uuid}/test/{carrier}',
    ...options
});

export const productsV2FoldProducts4 = <ThrowOnError extends boolean = true>(options: Options<ProductsV2FoldProducts4Data, ThrowOnError>): RequestResult<ProductsV2FoldProducts4Responses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV2FoldProducts4Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2FoldProducts4Response.parseAsync(data),
    url: '/api/v2/products/{product_uuid}/test/{carrier}/{state}',
    ...options
});

/**
 * Details
 *
 * Get the Product and its associated CarrierCoverageZoneProducts
 */
export const productsV2GetProductDetails = <ThrowOnError extends boolean = true>(options: Options<ProductsV2GetProductDetailsData, ThrowOnError>): RequestResult<ProductsV2GetProductDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV2GetProductDetailsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2GetProductDetailsResponse.parseAsync(data),
    url: '/api/v2/products/{uuid}',
    ...options
});

/**
 * Edit a Product's top-level fields
 */
export const productsV2EditProduct = <ThrowOnError extends boolean = true>(options: Options<ProductsV2EditProductData, ThrowOnError>): RequestResult<ProductsV2EditProductResponses, unknown, ThrowOnError> => (options.client ?? client).put<ProductsV2EditProductResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV2EditProductResponse.parseAsync(data),
    url: '/api/v2/products/{uuid}/edit',
    ...options
});

/**
 * Heartbeat — v2 FrontRunner services blueprint.
 */
export const servicesV2FrontrunnerV2Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ServicesV2FrontrunnerV2HeartbeatData, ThrowOnError>): RequestResult<ServicesV2FrontrunnerV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV2FrontrunnerV2HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV2FrontrunnerV2HeartbeatResponse.parseAsync(data),
    url: '/api/v2/services/frontrunner/heartbeat',
    ...options
});

/**
 * Pipeline Replay — run read-only Elgin discovery + payer ordering for an order.
 *
 * Query params:
 * no_cache (bool, default false): bypass the 24 h FrontRunner response cache.
 * raw (bool, default false): include the raw 271 JSON from the audit trail record.
 *
 * Returns 404 when the order does not exist in MongoDB.
 */
export const servicesV2FrontrunnerV2PipelineReplay = <ThrowOnError extends boolean = true>(options: Options<ServicesV2FrontrunnerV2PipelineReplayData, ThrowOnError>): RequestResult<ServicesV2FrontrunnerV2PipelineReplayResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV2FrontrunnerV2PipelineReplayResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV2FrontrunnerV2PipelineReplayResponse.parseAsync(data),
    url: '/api/v2/services/frontrunner/pipeline/{order_id}/replay',
    ...options
});

/**
 * Heartbeat — v2 services blueprint.
 */
export const servicesV2Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ServicesV2HeartbeatData, ThrowOnError>): RequestResult<ServicesV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV2HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zServicesV2HeartbeatResponse.parseAsync(data),
    url: '/api/v2/services/heartbeat',
    ...options
});

/**
 * Retrieve all active suppliers.
 */
export const suppliersV2GetAllSuppliers = <ThrowOnError extends boolean = true>(options?: Options<SuppliersV2GetAllSuppliersData, ThrowOnError>): RequestResult<SuppliersV2GetAllSuppliersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuppliersV2GetAllSuppliersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSuppliersV2GetAllSuppliersResponse.parseAsync(data),
    url: '/api/v2/suppliers/all',
    ...options
});

/**
 * Retrieve a supplier by UUID.
 */
export const suppliersV2Details = <ThrowOnError extends boolean = true>(options: Options<SuppliersV2DetailsData, ThrowOnError>): RequestResult<SuppliersV2DetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SuppliersV2DetailsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSuppliersV2DetailsResponse.parseAsync(data),
    url: '/api/v2/suppliers/details/{supplier_id}',
    ...options
});

/**
 * Health check endpoint.
 */
export const suppliersV2Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<SuppliersV2HeartbeatData, ThrowOnError>): RequestResult<SuppliersV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuppliersV2HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSuppliersV2HeartbeatResponse.parseAsync(data),
    url: '/api/v2/suppliers/heartbeat',
    ...options
});

/**
 * Search suppliers by query term and/or category.
 */
export const suppliersV2Search = <ThrowOnError extends boolean = true>(options?: Options<SuppliersV2SearchData, ThrowOnError>): RequestResult<SuppliersV2SearchResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuppliersV2SearchResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSuppliersV2SearchResponse.parseAsync(data),
    url: '/api/v2/suppliers/search',
    ...options
});

/**
 * Search suppliers by query term and/or category.
 */
export const suppliersV2Search2 = <ThrowOnError extends boolean = true>(options: Options<SuppliersV2Search2Data, ThrowOnError>): RequestResult<SuppliersV2Search2Responses, unknown, ThrowOnError> => (options.client ?? client).get<SuppliersV2Search2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zSuppliersV2Search2Response.parseAsync(data),
    url: '/api/v2/suppliers/search/{category}',
    ...options
});

/**
 * Insurance Card Presigned Upload URL
 *
 * Issues a short-lived presigned S3 PUT URL the FE uses to upload one card
 * image directly to S3. After the upload succeeds the FE registers the
 * resulting s3_object_key on the cache entry via
 * PUT /v3/insurance/cards/<verification_key>.
 *
 * Returns 404 when the verification_key has no cache entry.
 */
export const insuranceV3CardUploadUrl = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3CardUploadUrlData, ThrowOnError>): RequestResult<InsuranceV3CardUploadUrlResponses, InsuranceV3CardUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<InsuranceV3CardUploadUrlResponses, InsuranceV3CardUploadUrlErrors, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3CardUploadUrlResponse.parseAsync(data),
    url: '/api/v3/insurance/cards/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Insurance Card Upload
 *
 * Stores front and back card paths on the cached verification record.
 * Returns 404 if the verification_key has no cache entry.
 */
export const insuranceV3PutCards = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3PutCardsData, ThrowOnError>): RequestResult<InsuranceV3PutCardsResponses, InsuranceV3PutCardsErrors, ThrowOnError> => (options.client ?? client).put<InsuranceV3PutCardsResponses, InsuranceV3PutCardsErrors, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3PutCardsResponse.parseAsync(data),
    url: '/api/v3/insurance/cards/{verification_key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all carrier statuses, sorted by display order.
 *
 * Backs the carrier-admin status dropdown; the small, mostly-static row count
 * makes pagination unnecessary.
 */
export const insuranceV3CarrierStatusesV3ListCarrierStatuses = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV3CarrierStatusesV3ListCarrierStatusesData, ThrowOnError>): RequestResult<InsuranceV3CarrierStatusesV3ListCarrierStatusesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3CarrierStatusesV3ListCarrierStatusesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3CarrierStatusesV3ListCarrierStatusesResponse.parseAsync(data),
    url: '/api/v3/insurance/carrier-statuses',
    ...options
});

export const insuranceV3CarriersV3CreateCarrier = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3CarriersV3CreateCarrierData, ThrowOnError>): RequestResult<InsuranceV3CarriersV3CreateCarrierResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3CarriersV3CreateCarrierResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3CarriersV3CreateCarrierResponse.parseAsync(data),
    url: '/api/v3/insurance/carriers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const insuranceV3CarriersV3SearchCarriers = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV3CarriersV3SearchCarriersData, ThrowOnError>): RequestResult<InsuranceV3CarriersV3SearchCarriersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3CarriersV3SearchCarriersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3CarriersV3SearchCarriersResponse.parseAsync(data),
    url: '/api/v3/insurance/carriers/search',
    ...options
});

export const insuranceV3CarriersV3UpdateCarrier = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3CarriersV3UpdateCarrierData, ThrowOnError>): RequestResult<InsuranceV3CarriersV3UpdateCarrierResponses, unknown, ThrowOnError> => (options.client ?? client).patch<InsuranceV3CarriersV3UpdateCarrierResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3CarriersV3UpdateCarrierResponse.parseAsync(data),
    url: '/api/v3/insurance/carriers/{carrier_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const insuranceV3GetCarriersByState = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3GetCarriersByStateData, ThrowOnError>): RequestResult<InsuranceV3GetCarriersByStateResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV3GetCarriersByStateResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3GetCarriersByStateResponse.parseAsync(data),
    url: '/api/v3/insurance/carriers/{state}',
    ...options
});

export const insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverrides = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesData, ThrowOnError>): RequestResult<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponse.parseAsync(data),
    url: '/api/v3/insurance/code-eligibility-overrides',
    ...options
});

export const insuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverride = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideData, ThrowOnError>): RequestResult<InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideErrors, ThrowOnError> => (options.client ?? client).post<InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideErrors, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideResponse.parseAsync(data),
    url: '/api/v3/insurance/code-eligibility-overrides',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const insuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverride = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideData, ThrowOnError>): RequestResult<InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideErrors, ThrowOnError> => (options.client ?? client).delete<InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideErrors, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideResponse.parseAsync(data),
    url: '/api/v3/insurance/code-eligibility-overrides/{uuid}',
    ...options
});

export const insuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverride = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideData, ThrowOnError>): RequestResult<InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideErrors, ThrowOnError> => (options.client ?? client).patch<InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideErrors, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideResponse.parseAsync(data),
    url: '/api/v3/insurance/code-eligibility-overrides/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all coverage zones (states), sorted by abbreviation.
 *
 * Backs the carrier-admin state multi-select; the small, mostly-static row count
 * makes pagination unnecessary.
 */
export const insuranceV3CoverageZonesV3ListCoverageZones = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV3CoverageZonesV3ListCoverageZonesData, ThrowOnError>): RequestResult<InsuranceV3CoverageZonesV3ListCoverageZonesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3CoverageZonesV3ListCoverageZonesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3CoverageZonesV3ListCoverageZonesResponse.parseAsync(data),
    url: '/api/v3/insurance/coverage-zones',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const insuranceV3Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV3HeartbeatData, ThrowOnError>): RequestResult<InsuranceV3HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3HeartbeatResponse.parseAsync(data),
    url: '/api/v3/insurance/heartbeat',
    ...options
});

export const insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignations = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsData, ThrowOnError>): RequestResult<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponse.parseAsync(data),
    url: '/api/v3/insurance/network-status-designations',
    ...options
});

export const insuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignation = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationData, ThrowOnError>): RequestResult<InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationErrors, ThrowOnError> => (options.client ?? client).post<InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationErrors, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationResponse.parseAsync(data),
    url: '/api/v3/insurance/network-status-designations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const insuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignation = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationData, ThrowOnError>): RequestResult<InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationErrors, ThrowOnError> => (options.client ?? client).delete<InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationErrors, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationResponse.parseAsync(data),
    url: '/api/v3/insurance/network-status-designations/{uuid}',
    ...options
});

export const insuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignation = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationData, ThrowOnError>): RequestResult<InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationErrors, ThrowOnError> => (options.client ?? client).patch<InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationErrors, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationResponse.parseAsync(data),
    url: '/api/v3/insurance/network-status-designations/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Order Insurance Discovery
 *
 * Run insurance discovery for an order, write results to the order document, and return an acknowledgment.
 */
export const insuranceV3OrderDiscovery = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3OrderDiscoveryData, ThrowOnError>): RequestResult<InsuranceV3OrderDiscoveryResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3OrderDiscoveryResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/orders/{order_id}/discover', ...options });

/**
 * Order Eligibility Verification
 *
 * Run eligibility check for an order's insurance, write results to the order document, and return an acknowledgment.
 */
export const insuranceV3OrderEligibility = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3OrderEligibilityData, ThrowOnError>): RequestResult<InsuranceV3OrderEligibilityResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3OrderEligibilityResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/orders/{order_id}/verify/{member_id}', ...options });

export const insuranceV3PlanCodesV3CreatePlanCode = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3PlanCodesV3CreatePlanCodeData, ThrowOnError>): RequestResult<InsuranceV3PlanCodesV3CreatePlanCodeResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3PlanCodesV3CreatePlanCodeResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3PlanCodesV3CreatePlanCodeResponse.parseAsync(data),
    url: '/api/v3/insurance/plan-codes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const insuranceV3PlanCodesV3SearchPlanCodes = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV3PlanCodesV3SearchPlanCodesData, ThrowOnError>): RequestResult<InsuranceV3PlanCodesV3SearchPlanCodesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3PlanCodesV3SearchPlanCodesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3PlanCodesV3SearchPlanCodesResponse.parseAsync(data),
    url: '/api/v3/insurance/plan-codes/search',
    ...options
});

export const insuranceV3PlanCodesV3GetPlanCode = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3PlanCodesV3GetPlanCodeData, ThrowOnError>): RequestResult<InsuranceV3PlanCodesV3GetPlanCodeResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV3PlanCodesV3GetPlanCodeResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3PlanCodesV3GetPlanCodeResponse.parseAsync(data),
    url: '/api/v3/insurance/plan-codes/{plan_code_uuid}',
    ...options
});

export const insuranceV3PlanCodesV3UpdatePlanCode = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3PlanCodesV3UpdatePlanCodeData, ThrowOnError>): RequestResult<InsuranceV3PlanCodesV3UpdatePlanCodeResponses, unknown, ThrowOnError> => (options.client ?? client).patch<InsuranceV3PlanCodesV3UpdatePlanCodeResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3PlanCodesV3UpdatePlanCodeResponse.parseAsync(data),
    url: '/api/v3/insurance/plan-codes/{plan_code_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const insuranceV3PlansV3CreatePlan = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3PlansV3CreatePlanData, ThrowOnError>): RequestResult<InsuranceV3PlansV3CreatePlanResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3PlansV3CreatePlanResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3PlansV3CreatePlanResponse.parseAsync(data),
    url: '/api/v3/insurance/plans',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const insuranceV3PlansV3SearchPlans = <ThrowOnError extends boolean = true>(options?: Options<InsuranceV3PlansV3SearchPlansData, ThrowOnError>): RequestResult<InsuranceV3PlansV3SearchPlansResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3PlansV3SearchPlansResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3PlansV3SearchPlansResponse.parseAsync(data),
    url: '/api/v3/insurance/plans/search',
    ...options
});

export const insuranceV3PlansV3GetPlan = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3PlansV3GetPlanData, ThrowOnError>): RequestResult<InsuranceV3PlansV3GetPlanResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV3PlansV3GetPlanResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3PlansV3GetPlanResponse.parseAsync(data),
    url: '/api/v3/insurance/plans/{plan_uuid}',
    ...options
});

export const insuranceV3PlansV3UpdatePlan = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3PlansV3UpdatePlanData, ThrowOnError>): RequestResult<InsuranceV3PlansV3UpdatePlanResponses, unknown, ThrowOnError> => (options.client ?? client).patch<InsuranceV3PlansV3UpdatePlanResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3PlansV3UpdatePlanResponse.parseAsync(data),
    url: '/api/v3/insurance/plans/{plan_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Insurance Discovery: delegate to discovery service, then shape HTTP response and metrics.
 */
export const insuranceV3Discovery = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3DiscoveryData, ThrowOnError>): RequestResult<InsuranceV3DiscoveryResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3DiscoveryResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3DiscoveryResponse.parseAsync(data),
    url: '/api/v3/insurance/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const insuranceV3TestVerificationKey = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3TestVerificationKeyData, ThrowOnError>): RequestResult<InsuranceV3TestVerificationKeyResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV3TestVerificationKeyResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3TestVerificationKeyResponse.parseAsync(data),
    url: '/api/v3/insurance/test-verification/{verification_key}',
    ...options
});

/**
 * Patient Eligibility: delegate to verification service, then shape HTTP response and metrics.
 */
export const insuranceV3Verification = <ThrowOnError extends boolean = true>(options: Options<InsuranceV3VerificationData, ThrowOnError>): RequestResult<InsuranceV3VerificationResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3VerificationResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zInsuranceV3VerificationResponse.parseAsync(data),
    url: '/api/v3/insurance/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const productsV3GetProducts = <ThrowOnError extends boolean = true>(options: Options<ProductsV3GetProductsData, ThrowOnError>): RequestResult<ProductsV3GetProductsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV3GetProductsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV3GetProductsResponse.parseAsync(data),
    url: '/api/v3/products/',
    ...options
});

/**
 * Get Categories
 *
 * Returns a flat list of all active and visible product categories
 * (both parent and subcategories) filtered by the specified catalog.
 *
 * This endpoint does not require authentication.
 * Categories are filtered to include all categories (parents and subcategories)
 * that are both active and visible, belong to the specified catalog (Marketplace or D2C),
 * and are sorted alphabetically by name. Subcategories include their parent_uuid in the response.
 *
 * Query Parameters:
 * catalog (required): Must be either "Marketplace" or "D2C" (case-insensitive)
 *
 * Returns:
 * Response with metadata (timestamp, catalog) and payload (array of category objects).
 * Each category object contains uuid (UUID), label (string), parent_uuid (UUID or null),
 * description (string or null), and image_url (string or null).
 */
export const productsV3GetCategories = <ThrowOnError extends boolean = true>(options: Options<ProductsV3GetCategoriesData, ThrowOnError>): RequestResult<ProductsV3GetCategoriesResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV3GetCategoriesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV3GetCategoriesResponse.parseAsync(data),
    url: '/api/v3/products/categories',
    ...options
});

/**
 * Get Coverage Zones
 *
 * Returns active coverage zones that have at least one active, visible product.
 * Optionally filtered to zones whose products belong to the specified catalog.
 *
 * Query Parameters:
 * catalog (optional): "Marketplace" or "D2C" (case-insensitive). Omit for all zones.
 *
 * Returns:
 * Response with metadata (timestamp, catalog) and payload (array of zone objects).
 * Each zone contains uuid, label (state name), and abbreviation (2-letter code).
 */
export const productsV3GetCoverageZones = <ThrowOnError extends boolean = true>(options?: Options<ProductsV3GetCoverageZonesData, ThrowOnError>): RequestResult<ProductsV3GetCoverageZonesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV3GetCoverageZonesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV3GetCoverageZonesResponse.parseAsync(data),
    url: '/api/v3/products/coverage_zones/',
    ...options
});

/**
 * Export Flat Catalog
 *
 * Returns a flat list of every billable product × HCPC configuration.
 * Each row contains catalog, category, bundle name, product name, description, and HCPC code.
 *
 * Optionally filtered to a single catalog by name (case-sensitive, must match DB label).
 *
 * Path Parameters:
 * catalog_name (optional): Catalog label to filter by (e.g. "Marketplace", "D2C").
 * Omit to return rows across all catalogs.
 *
 * Returns:
 * Response with metadata (timestamp, catalog) and payload (list of flat catalog rows).
 */
export const productsV3ExportCatalog = <ThrowOnError extends boolean = true>(options?: Options<ProductsV3ExportCatalogData, ThrowOnError>): RequestResult<ProductsV3ExportCatalogResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV3ExportCatalogResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV3ExportCatalogResponse.parseAsync(data),
    url: '/api/v3/products/export-catalog/',
    ...options
});

/**
 * Export Flat Catalog
 *
 * Returns a flat list of every billable product × HCPC configuration.
 * Each row contains catalog, category, bundle name, product name, description, and HCPC code.
 *
 * Optionally filtered to a single catalog by name (case-sensitive, must match DB label).
 *
 * Path Parameters:
 * catalog_name (optional): Catalog label to filter by (e.g. "Marketplace", "D2C").
 * Omit to return rows across all catalogs.
 *
 * Returns:
 * Response with metadata (timestamp, catalog) and payload (list of flat catalog rows).
 */
export const productsV3ExportCatalog2 = <ThrowOnError extends boolean = true>(options: Options<ProductsV3ExportCatalog2Data, ThrowOnError>): RequestResult<ProductsV3ExportCatalog2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV3ExportCatalog2Responses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV3ExportCatalog2Response.parseAsync(data),
    url: '/api/v3/products/export-catalog/{catalog_name}',
    ...options
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV3Heartbeat = <ThrowOnError extends boolean = true>(options?: Options<ProductsV3HeartbeatData, ThrowOnError>): RequestResult<ProductsV3HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV3HeartbeatResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV3HeartbeatResponse.parseAsync(data),
    url: '/api/v3/products/heartbeat',
    ...options
});

/**
 * Get available time slots from Cal.com for the specified date range.
 */
export const schedulingV3GetSlots = <ThrowOnError extends boolean = true>(options: Options<SchedulingV3GetSlotsData, ThrowOnError>): RequestResult<SchedulingV3GetSlotsResponses, SchedulingV3GetSlotsErrors, ThrowOnError> => (options.client ?? client).get<SchedulingV3GetSlotsResponses, SchedulingV3GetSlotsErrors, ThrowOnError>({
    responseValidator: async (data) => await zSchedulingV3GetSlotsResponse.parseAsync(data),
    url: '/api/v3/scheduling/slots',
    ...options
});

/**
 * Reserve a time slot on Cal.com.
 */
export const schedulingV3ReserveSlot = <ThrowOnError extends boolean = true>(options: Options<SchedulingV3ReserveSlotData, ThrowOnError>): RequestResult<SchedulingV3ReserveSlotResponses, SchedulingV3ReserveSlotErrors, ThrowOnError> => (options.client ?? client).post<SchedulingV3ReserveSlotResponses, SchedulingV3ReserveSlotErrors, ThrowOnError>({
    responseValidator: async (data) => await zSchedulingV3ReserveSlotResponse.parseAsync(data),
    url: '/api/v3/scheduling/slots/reserve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Handle Cal.com webhook events for booking lifecycle.
 *
 * Events handled:
 * - BOOKING_RESCHEDULED: Update appointment times, transition order status to TELEHEALTH_UPCOMING if needed
 * - BOOKING_CANCELLED: Clear times, cancel the order (status: CANCELLED)
 */
export const schedulingV3CalcomWebhook = <ThrowOnError extends boolean = true>(options?: Options<SchedulingV3CalcomWebhookData, ThrowOnError>): RequestResult<SchedulingV3CalcomWebhookResponses, SchedulingV3CalcomWebhookErrors, ThrowOnError> => (options?.client ?? client).post<SchedulingV3CalcomWebhookResponses, SchedulingV3CalcomWebhookErrors, ThrowOnError>({
    responseValidator: async (data) => await zSchedulingV3CalcomWebhookResponse.parseAsync(data),
    url: '/api/v3/scheduling/webhooks/calcom',
    ...options
});

export const sessionsV3PreviewSession = <ThrowOnError extends boolean = true>(options: Options<SessionsV3PreviewSessionData, ThrowOnError>): RequestResult<SessionsV3PreviewSessionResponses, SessionsV3PreviewSessionErrors, ThrowOnError> => (options.client ?? client).get<SessionsV3PreviewSessionResponses, SessionsV3PreviewSessionErrors, ThrowOnError>({
    responseValidator: async (data) => await zSessionsV3PreviewSessionResponse.parseAsync(data),
    url: '/api/v3/sessions/preview/{token}',
    ...options
});

export const sessionsV3SaveSession = <ThrowOnError extends boolean = true>(options: Options<SessionsV3SaveSessionData, ThrowOnError>): RequestResult<SessionsV3SaveSessionResponses, SessionsV3SaveSessionErrors, ThrowOnError> => (options.client ?? client).post<SessionsV3SaveSessionResponses, SessionsV3SaveSessionErrors, ThrowOnError>({
    responseValidator: async (data) => await zSessionsV3SaveSessionResponse.parseAsync(data),
    url: '/api/v3/sessions/save',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const sessionsV3VerifySession = <ThrowOnError extends boolean = true>(options: Options<SessionsV3VerifySessionData, ThrowOnError>): RequestResult<SessionsV3VerifySessionResponses, SessionsV3VerifySessionErrors, ThrowOnError> => (options.client ?? client).post<SessionsV3VerifySessionResponses, SessionsV3VerifySessionErrors, ThrowOnError>({
    responseValidator: async (data) => await zSessionsV3VerifySessionResponse.parseAsync(data),
    url: '/api/v3/sessions/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check phone verification code.
 */
export const verifyV3Check = <ThrowOnError extends boolean = true>(options: Options<VerifyV3CheckData, ThrowOnError>): RequestResult<VerifyV3CheckResponses, VerifyV3CheckErrors, ThrowOnError> => (options.client ?? client).post<VerifyV3CheckResponses, VerifyV3CheckErrors, ThrowOnError>({
    responseValidator: async (data) => await zVerifyV3CheckResponse.parseAsync(data),
    url: '/api/v3/verify/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start phone verification by sending a code via SMS.
 */
export const verifyV3Start = <ThrowOnError extends boolean = true>(options: Options<VerifyV3StartData, ThrowOnError>): RequestResult<VerifyV3StartResponses, VerifyV3StartErrors, ThrowOnError> => (options.client ?? client).post<VerifyV3StartResponses, VerifyV3StartErrors, ThrowOnError>({
    responseValidator: async (data) => await zVerifyV3StartResponse.parseAsync(data),
    url: '/api/v3/verify/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV4CreateOrderDtcEndpoint = <ThrowOnError extends boolean = true>(options: Options<OrdersV4CreateOrderDtcEndpointData, ThrowOnError>): RequestResult<OrdersV4CreateOrderDtcEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV4CreateOrderDtcEndpointResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV4CreateOrderDtcEndpointResponse.parseAsync(data),
    url: '/api/v4/orders/create-dtc',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV4CreateOrderMcpEndpoint = <ThrowOnError extends boolean = true>(options: Options<OrdersV4CreateOrderMcpEndpointData, ThrowOnError>): RequestResult<OrdersV4CreateOrderMcpEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV4CreateOrderMcpEndpointResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV4CreateOrderMcpEndpointResponse.parseAsync(data),
    url: '/api/v4/orders/create-mcp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Endpoint to escalate an MCP order to the team. Adds an escalation tag to the Intercom conversation and posts a message to Slack.
 */
export const ordersV4EscalateMcpOrder = <ThrowOnError extends boolean = true>(options: Options<OrdersV4EscalateMcpOrderData, ThrowOnError>): RequestResult<OrdersV4EscalateMcpOrderResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV4EscalateMcpOrderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV4EscalateMcpOrderResponse.parseAsync(data),
    url: '/api/v4/orders/escalate-mcp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersV4PatchManualVerification = <ThrowOnError extends boolean = true>(options: Options<OrdersV4PatchManualVerificationData, ThrowOnError>): RequestResult<OrdersV4PatchManualVerificationResponses, OrdersV4PatchManualVerificationErrors, ThrowOnError> => (options.client ?? client).patch<OrdersV4PatchManualVerificationResponses, OrdersV4PatchManualVerificationErrors, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV4PatchManualVerificationResponse.parseAsync(data),
    url: '/api/v4/orders/{order_id}/insurance/{slot}/manual-verification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Product Configuration Audit (v4)
 *
 * Read-only audit surfacing three classes of product misconfiguration:
 * missing coverage zones, missing fee schedules, and duplicate fee schedules.
 *
 * Optional product_uuid query param scopes per-product checks to one product.
 * Duplicate fee schedule check always runs globally.
 * Auth: conduit_employee only.
 */
export const productsV4GetProductAudit = <ThrowOnError extends boolean = true>(options?: Options<ProductsV4GetProductAuditData, ThrowOnError>): RequestResult<ProductsV4GetProductAuditResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV4GetProductAuditResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV4GetProductAuditResponse.parseAsync(data),
    url: '/api/v4/products/audit',
    ...options
});

/**
 * Get Carriers (v4)
 *
 * Returns template carriers with an approved status and products in the given state.
 * Accepts an optional ?catalog param to restrict to carriers with products in that catalog.
 * Filters to carriers with a non-null frhc_id (Python-side, matching v2 behavior).
 */
export const productsV4GetCarriers = <ThrowOnError extends boolean = true>(options: Options<ProductsV4GetCarriersData, ThrowOnError>): RequestResult<ProductsV4GetCarriersResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV4GetCarriersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV4GetCarriersResponse.parseAsync(data),
    url: '/api/v4/products/carriers',
    ...options
});

/**
 * Get Catalog Products (v4)
 *
 * Carrier-scoped product list using the normalized product model.
 * Returns products in the v2 legacy_settings() shape so existing consumers receive
 * a structurally identical response.
 *
 * Required: carrier (slug), state (2-char abbreviation).
 * Optional: product_name, category_uuid, page, limit.
 */
export const productsV4GetCatalogProducts = <ThrowOnError extends boolean = true>(options: Options<ProductsV4GetCatalogProductsData, ThrowOnError>): RequestResult<ProductsV4GetCatalogProductsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV4GetCatalogProductsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV4GetCatalogProductsResponse.parseAsync(data),
    url: '/api/v4/products/catalog',
    ...options
});

/**
 * Get Single Catalog Product (v4)
 *
 * Returns one product in carrier/state context using the normalized model.
 * Returns 404 if the product is not found or not available in the given carrier/state.
 */
export const productsV4GetCatalogProduct = <ThrowOnError extends boolean = true>(options: Options<ProductsV4GetCatalogProductData, ThrowOnError>): RequestResult<ProductsV4GetCatalogProductResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV4GetCatalogProductResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV4GetCatalogProductResponse.parseAsync(data),
    url: '/api/v4/products/catalog/{product_uuid}',
    ...options
});

/**
 * Get All Categories (v4)
 *
 * Returns ProductCategory records filtered by catalog (default: Marketplace).
 * Pass ``catalog=`` (empty) to return all categories regardless of catalog association.
 * Fixes the v2 bug where the role was 'marketplace_employee' (non-existent); v4
 * uses 'marketplace_user'.
 */
export const productsV4GetAllCategories = <ThrowOnError extends boolean = true>(options?: Options<ProductsV4GetAllCategoriesData, ThrowOnError>): RequestResult<ProductsV4GetAllCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV4GetAllCategoriesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV4GetAllCategoriesResponse.parseAsync(data),
    url: '/api/v4/products/categories/all',
    ...options
});

/**
 * Search Categories (v4)
 *
 * Returns top-level product categories and their subcategories as a label-keyed dict.
 * No authentication required — mirrors v2 GET /products/categories/search behavior.
 * Cannot use @response decorator because the payload shape is variable (parent label →
 * list of subcategory labels). See D-8 in plan v5.
 */
export const productsV4SearchCategories = <ThrowOnError extends boolean = true>(options?: Options<ProductsV4SearchCategoriesData, ThrowOnError>): RequestResult<ProductsV4SearchCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV4SearchCategoriesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV4SearchCategoriesResponse.parseAsync(data),
    url: '/api/v4/products/categories/search',
    ...options
});

/**
 * Get Coverage Zones (v4)
 *
 * Returns all CoverageZone records regardless of product availability.
 * Accepts an optional ?catalog param — when provided, filters to zones that have at least
 * one product in that catalog (mirrors v3 /products/coverage_zones/ behaviour).
 * Identical to v2 GET /insurance/coverage_zones/all when no catalog filter is applied.
 */
export const productsV4GetCoverageZones = <ThrowOnError extends boolean = true>(options?: Options<ProductsV4GetCoverageZonesData, ThrowOnError>): RequestResult<ProductsV4GetCoverageZonesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV4GetCoverageZonesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV4GetCoverageZonesResponse.parseAsync(data),
    url: '/api/v4/products/coverage_zones',
    ...options
});

/**
 * Get Fee Schedule (v4)
 *
 * Returns fee/refill data for HCPC codes in a given carrier/state context.
 * Identical logic to v2 GET /insurance/fee_schedule/{carrier}/{state}.
 * No authentication required — matches v2 behavior.
 */
export const productsV4GetFeeSchedule = <ThrowOnError extends boolean = true>(options: Options<ProductsV4GetFeeScheduleData, ThrowOnError>): RequestResult<ProductsV4GetFeeScheduleResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV4GetFeeScheduleResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV4GetFeeScheduleResponse.parseAsync(data),
    url: '/api/v4/products/fee_schedule',
    ...options
});

/**
 * Search Products (v4 admin)
 *
 * Admin product search with filters for category, catalog, coverage zone, supplier, and
 * a free-text search term. Defaults to active/visible/approved products — the same scope
 * as v2 GET /products/search. Non-approved products are managed via Flask-admin directly.
 */
export const productsV4SearchProducts = <ThrowOnError extends boolean = true>(options?: Options<ProductsV4SearchProductsData, ThrowOnError>): RequestResult<ProductsV4SearchProductsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV4SearchProductsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV4SearchProductsResponse.parseAsync(data),
    url: '/api/v4/products/search',
    ...options
});

/**
 * Get Product Detail (v4 admin)
 *
 * Admin view of a single product across all carrier/state configurations.
 * Uses a direct query (not get_query()) so products without categories or CCZ records
 * are not silently 404'd — admin needs to see all products (D-9 in plan v5).
 *
 * Optional carrier/state params scope the response to a single carrier/state combination.
 * legacy_settings() slugifies carrier internally before matching (D-10 in plan v5).
 */
export const productsV4GetProductDetail = <ThrowOnError extends boolean = true>(options: Options<ProductsV4GetProductDetailData, ThrowOnError>): RequestResult<ProductsV4GetProductDetailResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV4GetProductDetailResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zProductsV4GetProductDetailResponse.parseAsync(data),
    url: '/api/v4/products/{product_uuid}',
    ...options
});

/**
 * Fetch a Healthie appointment by ID for the scheduling UI.
 */
export const schedulingV4GetAppointment = <ThrowOnError extends boolean = true>(options: Options<SchedulingV4GetAppointmentData, ThrowOnError>): RequestResult<SchedulingV4GetAppointmentResponses, SchedulingV4GetAppointmentErrors, ThrowOnError> => (options.client ?? client).get<SchedulingV4GetAppointmentResponses, SchedulingV4GetAppointmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zSchedulingV4GetAppointmentResponse.parseAsync(data),
    url: '/api/v4/scheduling/appointment',
    ...options
});

/**
 * Cancel a telehealth appointment.
 *
 * Updates the appointment status to cancelled in Healthie, which will trigger the appointment_updated webhook handling.
 */
export const schedulingV4CancelAppointment = <ThrowOnError extends boolean = true>(options: Options<SchedulingV4CancelAppointmentData, ThrowOnError>): RequestResult<SchedulingV4CancelAppointmentResponses, SchedulingV4CancelAppointmentErrors, ThrowOnError> => (options.client ?? client).post<SchedulingV4CancelAppointmentResponses, SchedulingV4CancelAppointmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zSchedulingV4CancelAppointmentResponse.parseAsync(data),
    url: '/api/v4/scheduling/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get days with available appointment slots from Healthie.
 */
export const schedulingV4GetDays = <ThrowOnError extends boolean = true>(options?: Options<SchedulingV4GetDaysData, ThrowOnError>): RequestResult<SchedulingV4GetDaysResponses, SchedulingV4GetDaysErrors, ThrowOnError> => (options?.client ?? client).get<SchedulingV4GetDaysResponses, SchedulingV4GetDaysErrors, ThrowOnError>({
    responseValidator: async (data) => await zSchedulingV4GetDaysResponse.parseAsync(data),
    url: '/api/v4/scheduling/days',
    ...options
});

/**
 * Reschedule a patient's appointment. The flow is:
 *
 * 1. Book a new appointment
 * 2. Mark any upcoming appointments of the same Healthie appointment-type as "Re-Scheduled"
 */
export const schedulingV4RescheduleAppointment = <ThrowOnError extends boolean = true>(options: Options<SchedulingV4RescheduleAppointmentData, ThrowOnError>): RequestResult<SchedulingV4RescheduleAppointmentResponses, SchedulingV4RescheduleAppointmentErrors, ThrowOnError> => (options.client ?? client).post<SchedulingV4RescheduleAppointmentResponses, SchedulingV4RescheduleAppointmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zSchedulingV4RescheduleAppointmentResponse.parseAsync(data),
    url: '/api/v4/scheduling/reschedule',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Book a telehealth appointment for a self-scheduling patient.
 *
 * Re-verifies DOB, books the telehealth appointment, attaches it to the
 * order, and transitions the order to TELEHEALTH_UPCOMING.
 */
export const schedulingV4BookSelfScheduledAppointment = <ThrowOnError extends boolean = true>(options: Options<SchedulingV4BookSelfScheduledAppointmentData, ThrowOnError>): RequestResult<SchedulingV4BookSelfScheduledAppointmentResponses, SchedulingV4BookSelfScheduledAppointmentErrors, ThrowOnError> => (options.client ?? client).post<SchedulingV4BookSelfScheduledAppointmentResponses, SchedulingV4BookSelfScheduledAppointmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zSchedulingV4BookSelfScheduledAppointmentResponse.parseAsync(data),
    url: '/api/v4/scheduling/schedule',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify a patient's identity before showing the self-scheduling UI.
 *
 * Checks the patient DOB against the order and confirms the order is in
 * CONTACTING_PATIENT status. Returns context needed by the FE
 * (state for slot filtering).
 */
export const schedulingV4VerifyPatientBooking = <ThrowOnError extends boolean = true>(options: Options<SchedulingV4VerifyPatientBookingData, ThrowOnError>): RequestResult<SchedulingV4VerifyPatientBookingResponses, SchedulingV4VerifyPatientBookingErrors, ThrowOnError> => (options.client ?? client).post<SchedulingV4VerifyPatientBookingResponses, SchedulingV4VerifyPatientBookingErrors, ThrowOnError>({
    responseValidator: async (data) => await zSchedulingV4VerifyPatientBookingResponse.parseAsync(data),
    url: '/api/v4/scheduling/schedule/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get available time slots from Healthie for the specified date range.
 */
export const schedulingV4GetSlots = <ThrowOnError extends boolean = true>(options?: Options<SchedulingV4GetSlotsData, ThrowOnError>): RequestResult<SchedulingV4GetSlotsResponses, SchedulingV4GetSlotsErrors, ThrowOnError> => (options?.client ?? client).get<SchedulingV4GetSlotsResponses, SchedulingV4GetSlotsErrors, ThrowOnError>({
    responseValidator: async (data) => await zSchedulingV4GetSlotsResponse.parseAsync(data),
    url: '/api/v4/scheduling/slots',
    ...options
});

export const trackingV4VerifyAndGetTracking = <ThrowOnError extends boolean = true>(options: Options<TrackingV4VerifyAndGetTrackingData, ThrowOnError>): RequestResult<TrackingV4VerifyAndGetTrackingResponses, unknown, ThrowOnError> => (options.client ?? client).post<TrackingV4VerifyAndGetTrackingResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zTrackingV4VerifyAndGetTrackingResponse.parseAsync(data),
    url: '/api/v4/tracking/{public_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Order Details (v5)
 *
 * Identical response shape to GET /v1/orders/<order_id> with metadata.version = 5.
 * Replaces per-item product queries with two batch queries (Product + HCPC prefetch),
 * eliminating the N+1 pattern for orders with UUID product references.
 *
 * v1 remains live for orders with legacy product_id values.
 */
export const ordersV5OrderDetails = <ThrowOnError extends boolean = true>(options: Options<OrdersV5OrderDetailsData, ThrowOnError>): RequestResult<OrdersV5OrderDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV5OrderDetailsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zOrdersV5OrderDetailsResponse.parseAsync(data),
    url: '/api/v5/orders/{order_id}',
    ...options
});
